// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zBenefitPlansVisionExtendedBenefit = z.object({
    premiumProgressiveType: z.string().nullish(),
    premiumProgressiveCopayAmount: z.number().gte(0).nullish(),
    premiumProgressiveAllowanceAmount: z.number().gte(0).nullish(),
    conventionalContactType: z.string().nullish(),
    conventionalContactAdditionalDiscountAmount: z.number().gte(0).nullish(),
    conventionalContactAllowanceAmount: z.number().gte(0).nullish(),
    disposableContactType: z.string().nullish(),
    disposableContactCopayAmount: z.number().gte(0).nullish(),
    disposableContactAllowanceAmount: z.number().gte(0).nullish(),
    contactLensMedNecType: z.string().nullish(),
    contactLensMedNecCopayAmount: z.number().gte(0).nullish(),
    contactLensMedNecAllowanceAmount: z.number().gte(0).nullish(),
    progressiveLensesType: z.string().nullish(),
    progressiveLensesCopayAmount: z.number().gte(0).nullish(),
    progressiveLensesAllowanceAmount: z.number().gte(0).nullish(),
    eligibilityHours: z.string().nullish()
});

export const zBenefitPlansDentalExtendedBenefit = z.object({
    preventativeAdvantage: z.string().nullish(),
    oralExams: z.string().nullish(),
    oralExamFrequency: z.string().nullish(),
    cleaningFrequency: z.string().nullish(),
    bitewingXRays: z.string().nullish(),
    fullMouthXRays: z.string().nullish(),
    fullMouthXRaysFrequency: z.string().nullish(),
    fluorideTreatments: z.string().nullish(),
    amalgamSilverFillings: z.string().nullish(),
    simpleExtractions: z.string().nullish(),
    bridgesAndDentures: z.string().nullish(),
    bridgesAndDenturesFrequency: z.string().nullish(),
    crowns: z.string().nullish(),
    crownsFrequency: z.string().nullish(),
    tmj: z.string().nullish(),
    workInProgressIncluded: z.string().nullish(),
    openOrClosedContract: z.string().nullish(),
    eligibilityHours: z.string().nullish(),
    weightedAvgOutOfPocket: z.number().nullish()
});

export const zBenefitPlansBasicLifeExtendedBenefit = z.object({
    eligibilityHours: z.string().nullish(),
    waiverOfPremiumEligibility: z.string().nullish(),
    waiverOfPremiumWaitingPeriod: z.string().nullish(),
    waiverOfPremiumDuration: z.string().nullish(),
    airBag: z.string().nullish(),
    commonCarrier: z.string().nullish(),
    repatriation: z.string().nullish(),
    seatBelt: z.string().nullish(),
    eapFaceToFaceVisitsLimitType: z.string().nullish(),
    eapVisitCount: z.string().nullish(),
    travelAid: z.string().nullish()
});

export const zBenefitPlansStdExtendedBenefit = z.object({
    eligibilityHours: z.string().nullish(),
    minimumBenefitType: z.string().nullish(),
    minimumBenefitAmount: z.number().gte(0).nullish(),
    minimumBenefit: z.number().gte(0).nullish(),
    firstDayHospital: z.string().nullish(),
    partialDisabilityFormula: z.string().nullish(),
    partialDisability: z.string().nullish(),
    earningsTest: z.string().nullish(),
    portability: z.string().nullish(),
    rehabilitativeIncentiveBenefit: z.string().nullish(),
    recurrentDisability: z.string().nullish(),
    w2Prep: z.string().nullish(),
    claimsIntake: z.string().nullish(),
    statutoryDiIntegration: z.string().nullish(),
    pflIntegration: z.string().nullish()
});

export const zBenefitPlansLtdExtendedBenefit = z.object({
    eligibilityHours: z.string().nullish(),
    zeroDayResidual: z.string().nullish(),
    indexingOfPreDisabilityEarnings: z.string().nullish(),
    returnToWorkIncentivePeriod: z.string().nullish(),
    definitionOfPartialDisability: z.string().nullish(),
    otherIncomeIntegration: z.string().nullish(),
    socialSecurityIntegration: z.string().nullish(),
    trialWorkDays: z.string().nullish(),
    survivorBenefit: z.string().nullish(),
    worksiteModification: z.string().nullish(),
    dayCareBenefits: z.string().nullish(),
    reasonableAccommodation: z.string().nullish(),
    rehabilitativeIncentiveBenefit: z.string().nullish(),
    prudentPerson: z.string().nullish(),
    selfReportedLimitations: z.string().nullish(),
    specialConditionsLimitations: z.string().nullish(),
    recoveryBenefit: z.string().nullish(),
    residencyRestriction: z.string().nullish(),
    progressiveIllness: z.string().nullish(),
    infectiousContagiousDisease: z.string().nullish(),
    specificLossAdDAndLossOfSight: z.string().nullish(),
    activitiesOfDailyLiving: z.string().nullish(),
    maximumCapacity: z.string().nullish(),
    retirementIncomeProtection: z.string().nullish(),
    recurrentDisability: z.string().nullish(),
    portability: z.string().nullish(),
    eap: z.string().nullish(),
    minimumAmountType: z.string().nullish(),
    minimumAmount: z.number().gte(0).nullish(),
    mandatoryRehabilitation: z.string().nullish()
});

export const zBenefitPlansCriticalIllnessConditionBenefit = z.object({
    type: z.string().nullish(),
    amount: z.number().nullish()
});

export const zBenefitPlansCriticalIllnessExtendedBenefit = z.object({
    skinCancer: zBenefitPlansCriticalIllnessConditionBenefit.nullish(),
    advancedParkinsons: zBenefitPlansCriticalIllnessConditionBenefit.nullish(),
    als: zBenefitPlansCriticalIllnessConditionBenefit.nullish(),
    eligibilityHours: z.string().nullish()
});

export const zBenefitPlansAccidentExtendedBenefit = z.object({
    accidentalDeathDismemberment: z.string().nullish(),
    eligibilityHours: z.string().nullish()
});

export const zBenefitPlansCancerExtendedBenefit = z.object({
    eligibilityHours: z.string().nullish()
});

export const zBenefitPlansWholeLifeExtendedBenefit = z.object({
    longTermCare: z.string().nullish()
});

export const zBenefitPlansHospitalIndemnityExtendedBenefit = z.object({
    eligibility: z.string().nullish(),
    twentyFourHourCoverage: z.string().nullish(),
    pregnancy: z.string().nullish(),
    newbornNurseryCare: z.string().nullish(),
    eligibilityHours: z.string().nullish(),
    pregnancyWaitingPeriodNote: z.string().nullish()
});

export const zBenefitPlansUpdateBenefitPlanGroupRequest = z.object({
    nickname: z.string().nullish(),
    footnoteHeaderLabel: z.string().nullish(),
    illustratedFrom: z.string().nullish(),
    size: z.number().int().gte(1).lte(3).optional(),
    expectedSize: z.number().int().gte(1).optional()
});

export const zBenefitPlansReorderRequest = z.object({
    orderedIds: z.array(z.string()).min(1)
});

/**
 * On-demand premium rollups for a group: group totals plus per-plan
 * premiums. Premiums are computed from the rates and never persisted.
 *
 */
export const zBenefitPlansBenefitPlanGroupPremiumsResponse = z.object({
    id: z.string().uuid(),
    totalMonthlyPremium: z.number(),
    totalAnnualPremium: z.number(),
    benefitPlans: z.array(z.object({
        id: z.string().uuid(),
        monthlyPremium: z.number().optional(),
        annualPremium: z.number().optional()
    }))
});

export const zBenefitPlansEligibilityClass = z.object({
    id: z.string().uuid(),
    name: z.string()
});

/**
 * A Critical Illness plan's flat rider charges, in USD, one per covered
 * relationship. BTX-local, not part of canonical v5. On a request each
 * charge is patched on its own: a number sets it, null clears it, and an
 * omitted charge keeps its stored value. Each charge is rounded to three
 * decimal places. A negative charge, or any charge on a plan outside the
 * Critical Illness coverage, is rejected with 400. On a response the
 * object is omitted when no charge is set, and an unset charge is null.
 *
 */
export const zProposalsRiderCharges = z.object({
    employee: z.number().gte(0).nullish(),
    spouse: z.number().gte(0).nullish(),
    child: z.number().gte(0).nullish()
});

/**
 * Group-level field edits for a proposal plan group. All fields are
 * optional; omitted fields are left unchanged.
 *
 */
export const zProposalsUpdateProposalPlanGroupFieldsRequest = z.object({
    padSuppressed: z.boolean().optional(),
    footnote: z.string().nullish(),
    enrollmentDecision: z.enum(['kept_current', 'used_carrier']).optional()
});

/**
 * Summary-level proposal data returned by the list endpoint
 */
export const zProposalsProposalSummaryResponse = z.object({
    id: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    carrierId: z.string().optional(),
    carrierName: z.string().optional(),
    status: z.string().optional(),
    rfpVersion: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    isActiveVersion: z.boolean().optional(),
    requoteReviewState: z.enum(['pending', 'actioned']).optional(),
    receivedAt: z.string().datetime().nullish(),
    origin: z.enum([
        'carrier',
        'analyst',
        'document'
    ]).optional(),
    documentId: z.string().nullish(),
    documentName: z.string().nullish()
});

/**
 * A single rate row within a proposal rate schedule.
 */
export const zProposalsProposalRateResponse = z.object({
    id: z.string().optional(),
    proposalRateScheduleId: z.string().optional(),
    position: z.number().int().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    coverageTierCode: z.string().nullish(),
    numberOfLives: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    rate: z.number().nullish(),
    volume: z.number().nullish(),
    carrierNumberOfLives: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    carrierVolume: z.number().optional(),
    currentNumberOfLives: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    currentVolume: z.number().optional(),
    enrollmentVarianceFlagged: z.boolean().optional(),
    ageBandLower: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ageBandUpper: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    gender: z.string().nullish(),
    isTobaccoRated: z.boolean().nullish(),
    unit: z.string().nullish()
});

/**
 * A rate schedule attached to a proposal plan.
 */
export const zProposalsProposalRateScheduleResponse = z.object({
    id: z.string().optional(),
    proposalPlanId: z.string().optional(),
    position: z.number().int().optional(),
    rateCategory: z.enum([
        'current',
        'renewal',
        'revisedRenewal'
    ]).optional(),
    enrollmentDecision: z.enum(['kept_current', 'used_carrier']).optional(),
    enrollmentDecidedBy: z.string().optional(),
    enrollmentDecidedAt: z.string().datetime().optional(),
    enrollmentNeedsDecision: z.boolean().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    rateDesign: z.string().optional(),
    numberOfLives: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    pepm: z.number().nullish(),
    rates: z.array(zProposalsProposalRateResponse).optional()
});

/**
 * The v5 group RFP a submission sends carriers: `PostGroupRfp` as the
 * Centro specification defines it, in the `specification` repository at
 * `specs/components/group_rfp.yaml#/components/schemas/PostGroupRfp`
 * (bundled as `specs/group_rfp-5.0.yaml`, published on the API docs
 * site), and as `canonical/v5` implements it in platform. Its top level
 * is listed here; the nested objects are as that definition gives them.
 *
 */
export const zRfpsPostGroupRfp = z.object({
    identifier: z.string().uuid(),
    versionNumber: z.number().int().nullish(),
    effectiveDate: z.string().date(),
    dueDate: z.string().date(),
    notes: z.string().max(4096).optional(),
    employer: z.record(z.unknown()),
    benefitClasses: z.array(z.record(z.unknown())),
    census: z.array(z.record(z.unknown())).optional(),
    files: z.array(z.record(z.unknown())),
    broker: z.record(z.unknown()),
    generalAgent: z.record(z.unknown()),
    additionalCoverages: z.record(z.unknown()).optional(),
    coverages: z.array(z.record(z.unknown()))
});

export const zRfpsRfpPayloadExportResponse = z.object({
    specVersion: z.string(),
    data: zRfpsPostGroupRfp
});

export const zRfpsEligibilityClass = z.object({
    id: z.string().uuid(),
    name: z.string()
});

export const zRfpsSetCoverageCompletionRequest = z.object({
    isComplete: z.boolean()
});

export const zRfpsCoverageCompletionValidationError = z.object({
    field: z.string(),
    message: z.string()
});

export const zRfpsCoverageCompletionValidationErrorResponse = z.object({
    errors: z.array(zRfpsCoverageCompletionValidationError)
});

export const zRfpsCarrierNoteExistenceResponse = z.object({
    carrierIds: z.array(z.string())
});

export const zRfpsFieldCommentUpsert = z.object({
    fieldPath: z.string(),
    comment: z.string().max(1024).nullish(),
    needsReview: z.boolean().optional(),
    manuallyEdited: z.boolean().optional(),
    isBenchmarkField: z.boolean().optional(),
    isValidated: z.boolean().optional(),
    aiOriginalValue: z.string().nullish()
});

export const zRfpsBenefitPlanFieldCommentsRequest = z.object({
    benefitPlanId: z.string().uuid(),
    fields: z.array(zRfpsFieldCommentUpsert).min(1)
});

export const zRfpsUpsertFieldCommentsRequest = z.object({
    benefitPlans: z.array(zRfpsBenefitPlanFieldCommentsRequest).min(1)
});

export const zRfpsFieldCommentResponse = z.object({
    id: z.string().uuid(),
    fieldPath: z.string(),
    comment: z.string().optional(),
    needsReview: z.boolean(),
    manuallyEdited: z.boolean(),
    isBenchmarkField: z.boolean(),
    isValidated: z.boolean(),
    aiOriginalValue: z.string().optional()
});

export const zRfpsBenefitPlanFieldCommentsResponse = z.object({
    benefitPlanId: z.string().uuid(),
    fieldComments: z.array(zRfpsFieldCommentResponse)
});

export const zRfpsUpsertFieldCommentsResponse = z.object({
    benefitPlans: z.array(zRfpsBenefitPlanFieldCommentsResponse)
});

/**
 * This is a list of all possible plan types across all the coverage types.
 */
export const zBenefitPlanTypeEnum = z.enum([
    'ppo',
    'hmo',
    'epo',
    'pos',
    'indemnity',
    'notApplicable'
]);

export const zBenefitPlansProductType = zBenefitPlanTypeEnum;

export const zProposalsProductType = zBenefitPlanTypeEnum;

export const zRfpsProductType = zBenefitPlanTypeEnum;

/**
 * This is the list of funding types. In the simplest terms, this is about how the claims are funded. There are other factors involved as well.
 */
export const zFundingTypeEnum = z.enum([
    'fullyInsured',
    'selfFundedASO',
    'selfFundedATP',
    'checkCutting',
    'levelFunded',
    'notApplicable'
]);

export const zBenefitPlansFundingType = zFundingTypeEnum;

export const zRfpsFundingType = zFundingTypeEnum;

/**
 * This is a list of option names that we allow for dual option plans.
 */
export const zOptionNameEnum = z.enum([
    'high',
    'medium',
    'low',
    'notApplicable'
]);

export const zBenefitPlansOptionName = zOptionNameEnum;

export const zProposalsOptionName = zOptionNameEnum;

export const zRfpsOptionName = zOptionNameEnum;

/**
 * This field tells us if the requested plan design matches the in-force plan (current) or if it is an alternate plan design (alternate). For a virgin line of coverage, use newBusiness.
 */
export const zPolicyPeriodEnum = z.enum([
    'newBusiness',
    'current',
    'alternate'
]);

export const zBenefitPlansPolicyPeriod = zPolicyPeriodEnum;

/**
 * Clone an existing group, copying all plan data.
 */
export const zBenefitPlansCreateBenefitPlanGroupFromExisting = z.object({
    referenceGroupId: z.string(),
    insertPosition: z.enum([
        'before',
        'after',
        'end'
    ]).optional().default('end'),
    benefitPlanGroup: z.object({
        policyPeriod: zPolicyPeriodEnum.optional(),
        nickname: z.string().optional()
    }).optional()
});

export const zBenefitPlansBenefitPlanGroupInput = z.object({
    productType: zBenefitPlanTypeEnum.optional(),
    policyPeriod: zPolicyPeriodEnum.optional(),
    nickname: z.string().optional(),
    size: z.number().int().gte(1).lte(3).optional(),
    position: z.number().int().optional()
});

export const zRfpsPolicyPeriod = zPolicyPeriodEnum;

/**
 * The time unit for how long rates are guaranteed to stay the same.
 */
export const zRateGuaranteeTypeEnum = z.enum([
    'months',
    'years',
    'notIncluded',
    'notOffered'
]);

/**
 * Rate guarantee period (e.g. 24 months).
 */
export const zProposalsRateGuarantee = z.object({
    type: zRateGuaranteeTypeEnum.optional(),
    amount: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional()
}).nullable();

/**
 * Plan-level attribute edits for a proposal plan. All fields are optional;
 * omitted fields are left unchanged. Benefits are updated separately via
 * PATCH /proposal-plans/{id}/benefits.
 *
 */
export const zProposalsUpdateProposalPlanFieldsRequest = z.object({
    name: z.string().max(128).optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().optional(),
    rateGuarantee: zProposalsRateGuarantee.optional(),
    rateCap: z.string().optional(),
    riderCharges: zProposalsRiderCharges.optional()
});

/**
 * Details for an accident benefit including type and amount.
 */
export const zAccidentBenefitDetails = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
 */
export const zRfpAccidentBenefitTypeEnum = z.enum([
    'dollarAmount',
    'includedInLumpSumBenefitPayout',
    'includedWithHospitalAdmission',
    'notIncluded'
]);

export const zRfpAccidentBenefitDetails = zAccidentBenefitDetails.and(z.object({
    type: zRfpAccidentBenefitTypeEnum.optional()
}));

/**
 * Indicates when the accident event may occur to be eligible for coverage.
 */
export const zRfpAccidentCoverageTypeEnum = z.enum(['onAndOffJob', 'offJob']);

/**
 * Maximum benefit type for accident coverage.
 */
export const zRfpAccidentMaxBenefitTypeEnum = z.enum(['upToDollarAmount', 'notIncluded']);

export const zRfpAccidentMaxBenefitDetails = zAccidentBenefitDetails.and(z.object({
    type: zRfpAccidentMaxBenefitTypeEnum.optional()
}));

/**
 * Indicates dollar amount carrier will cover as benefit for specific services that should not include hospital admission benefits.
 */
export const zRfpAccidentSpecificBenefitTypeEnum = z.enum([
    'dollarAmount',
    'includedInLumpSumBenefitPayout',
    'notIncluded'
]);

export const zRfpAccidentSpecificBenefitDetails = zAccidentBenefitDetails.and(z.object({
    type: zRfpAccidentSpecificBenefitTypeEnum.optional()
}));

/**
 * Describes the benefit configuration available.
 */
export const zRfpBasicLifeBenefitAmountTypeEnum = z.enum([
    'increments',
    'dollarAmount',
    'salaryMultiplier',
    'salaryMultiplierPlusDollarAmount'
]);

/**
 * Describes the child benefit configuration available for RFP.
 */
export const zRfpBasicLifeChildBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

/**
 * Describes the guarantee issue configuration available.
 */
export const zRfpBasicLifeGuaranteeIssueTypeEnum = z.enum([
    'dollarAmount',
    'salaryMultiplierWithCap',
    'salaryMultiplierWithDollarAmountPlusAdditionalAmount',
    'allGuaranteeIssue',
    'notIncluded'
]);

/**
 * The object type for basic life AD&D benefits.
 */
export const zRfpBasicLifeObjectTypeEnum = z.enum(['basicLifeAdnd']);

/**
 * Describes the spouse benefit configuration available for RFP.
 */
export const zRfpBasicLifeSpouseBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

/**
 * Indicates the unit of time for the waiting period.
 */
export const zCancerInitialDiagnosisWaitingPeriodTypeEnum = z.enum(['days', 'months']);

/**
 * The object type for cancer benefits.
 */
export const zCancerObjectTypeEnum = z.enum(['cancer']);

export const zBaseCancerBenefit = z.object({
    objectType: zCancerObjectTypeEnum,
    initialDiagnosisWaitingPeriod: z.object({
        type: zCancerInitialDiagnosisWaitingPeriodTypeEnum.optional(),
        duration: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
    }).optional()
});

/**
 * Indicates the type of benefit available for RFP.
 */
export const zRfpCancerAmountBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

export const zRfpCancerAmountBenefit = z.object({
    type: zRfpCancerAmountBenefitTypeEnum,
    amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates the type of hospice benefit available for RFP.
 */
export const zRfpCancerHospiceBenefitTypeEnum = z.enum([
    'dollarAmount',
    'dollarAmountPerDayPerLifetime',
    'notIncluded'
]);

export const zRfpCancerHospiceBenefit = z.object({
    type: zRfpCancerHospiceBenefitTypeEnum,
    amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
    duration: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates the type of schedule benefit available for RFP.
 */
export const zRfpCancerScheduleBenefitTypeEnum = z.enum(['scheduleUpToDollarAmount', 'notIncluded']);

export const zRfpCancerScheduleBenefit = z.object({
    type: zRfpCancerScheduleBenefitTypeEnum,
    amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates the percentage at which a repeat occurrence of the same illness will be covered, and the time period compared to the initial illness covered.
 */
export const zBaseAdditionalOccurrenceOfSameIllness = z.object({
    type: z.unknown(),
    months: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates what carrier will cover as benefit for this service.
 */
export const zBaseIllnessCoverage = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence).
 */
export const zBaseMaximumPayout = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the percentage at which an additional illness (in a different category) will be covered, and the time period compared to the initial illness covered.
 */
export const zBaseOccurrenceOfDifferentIllness = z.object({
    type: z.unknown(),
    months: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates dollar amount of available reimbursement for member completing wellness initiative(s).
 */
export const zBaseWellnessBenefit = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Describes the benefit configuration available for employee.
 */
export const zCriticalIllnessEmployeeBenefitDescriptionTypeEnum = z.enum([
    'increments',
    'percentage',
    'dollarAmount',
    'multipleOptions'
]);

/**
 * Indicates the maximum amount of benefit the employee can elect.
 */
export const zCriticalIllnessEmployeeMaximumTypeEnum = z.enum([
    'dollarAmount',
    'percentageOfEeBenefit',
    'percentageOfEeBenefitAndDollarAmount'
]);

/**
 * The object type for critical illness benefits.
 */
export const zCriticalIllnessObjectTypeEnum = z.enum(['criticalIllness']);

/**
 * Indicates whether the available benefit(s) are based on member age at time of policy issuance, or based member attained age in conjunction with age-band rules.
 */
export const zRfpAgeBasisEnum = z.enum([
    'issueAge',
    'attainedAge',
    'notIncluded'
]);

/**
 * Describes the benefit configuration available for child.
 */
export const zRfpCriticalIllnessChildBenefitDescriptionTypeEnum = z.enum([
    'percentageOfEeBenefit',
    'flatAmount',
    'notIncluded'
]);

/**
 * Describes the benefit configuration available for child.
 */
export const zRfpCriticalIllnessChildBenefitDescription = z.object({
    type: zRfpCriticalIllnessChildBenefitDescriptionTypeEnum,
    amounts: z.array(z.number().gte(0)).max(100000).optional(),
    minimum: z.number().gte(0).optional()
});

/**
 * Child critical illness benefit configuration.
 */
export const zRfpCriticalIllnessChildBenefit = z.object({
    benefitDescription: zRfpCriticalIllnessChildBenefitDescription
});

/**
 * Describes the benefit configuration available for employee.
 */
export const zRfpCriticalIllnessEmployeeBenefitDescription = z.object({
    type: zCriticalIllnessEmployeeBenefitDescriptionTypeEnum,
    amounts: z.array(z.number().gte(0)).max(100000).optional(),
    minimum: z.number().gte(0).optional()
});

/**
 * Indicates the maximum amount of benefit the employee can elect.
 */
export const zRfpCriticalIllnessEmployeeBenefitMaximum = z.object({
    type: zCriticalIllnessEmployeeMaximumTypeEnum,
    dollarAmount: z.number().gte(0).optional(),
    percent: z.number().gte(0).optional()
});

/**
 * Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability.
 */
export const zRfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum = z.enum([
    'percentageOfEeBenefit',
    'flatAmount',
    'notIncluded'
]);

/**
 * Indicates the amount of Employee Benefit available without having to provide Evidence of Insurability.
 */
export const zRfpCriticalIllnessEmployeeGuaranteeIssue = z.object({
    type: zRfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Employee critical illness benefit configuration.
 */
export const zRfpCriticalIllnessEmployeeBenefit = z.object({
    benefitDescription: zRfpCriticalIllnessEmployeeBenefitDescription,
    benefitMaximum: zRfpCriticalIllnessEmployeeBenefitMaximum.optional(),
    guaranteeIssue: zRfpCriticalIllnessEmployeeGuaranteeIssue.optional()
});

/**
 * Describes the benefit configuration available for spouse.
 */
export const zRfpCriticalIllnessSpouseBenefitDescriptionTypeEnum = z.enum([
    'increments',
    'percentage',
    'dollarAmount',
    'multipleOptions',
    'notIncluded'
]);

/**
 * Describes the benefit configuration available for spouse.
 */
export const zRfpCriticalIllnessSpouseBenefitDescription = z.object({
    type: zRfpCriticalIllnessSpouseBenefitDescriptionTypeEnum,
    amounts: z.array(z.number().gte(0)).max(100000).optional(),
    minimum: z.number().gte(0).optional()
});

/**
 * Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability.
 */
export const zRfpCriticalIllnessSpouseGuaranteeIssueTypeEnum = z.enum([
    'percentageOfEeBenefit',
    'flatAmount',
    'notIncluded'
]);

/**
 * Indicates the amount of Spouse Benefit available without having to provide Evidence of Insurability.
 */
export const zRfpCriticalIllnessSpouseGuaranteeIssue = z.object({
    type: zRfpCriticalIllnessSpouseGuaranteeIssueTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the maximum amount of benefit the spouse can elect.
 */
export const zRfpCriticalIllnessSpouseMaximumTypeEnum = z.enum([
    'dollarAmount',
    'percentageOfEeBenefit',
    'percentageOfEeBenefitAndDollarAmount',
    'notIncluded'
]);

/**
 * Indicates the maximum amount of benefit the spouse can elect.
 */
export const zRfpCriticalIllnessSpouseBenefitMaximum = z.object({
    type: zRfpCriticalIllnessSpouseMaximumTypeEnum,
    dollarAmount: z.number().gte(0).optional(),
    percent: z.number().gte(0).optional()
});

/**
 * Spouse critical illness benefit configuration.
 */
export const zRfpCriticalIllnessSpouseBenefit = z.object({
    benefitDescription: zRfpCriticalIllnessSpouseBenefitDescription,
    benefitMaximum: zRfpCriticalIllnessSpouseBenefitMaximum.optional(),
    guaranteeIssue: zRfpCriticalIllnessSpouseGuaranteeIssue.optional()
});

/**
 * Indicates what carrier will cover as benefit for this service.
 */
export const zRfpIllnessTypeEnum = z.enum(['percentage', 'notIncluded']);

export const zRfpIllnessCoverage = zBaseIllnessCoverage.and(z.object({
    type: zRfpIllnessTypeEnum.optional()
}));

/**
 * Indicates the total amount the plan will payout to any given employee (after factoring in recurrence and second occurrence).
 */
export const zRfpMaximumPayoutTypeEnum = z.enum([
    'dollarAmount',
    'percentage',
    'noLimit',
    'unlimited',
    'willNotPayForThirdOrLaterOccurrence',
    'notIncluded'
]);

export const zRfpMaximumPayout = zBaseMaximumPayout.and(z.object({
    type: zRfpMaximumPayoutTypeEnum.optional()
}));

/**
 * Indicates coverage and time period for illness occurrences.
 */
export const zRfpOccurrenceTypeEnum = z.enum([
    'months',
    'included',
    'notIncluded'
]);

export const zRfpAdditionalOccurrenceOfSameIllness = zBaseAdditionalOccurrenceOfSameIllness.and(z.object({
    type: zRfpOccurrenceTypeEnum.optional()
}));

export const zRfpOccurrenceOfDifferentIllness = zBaseOccurrenceOfDifferentIllness.and(z.object({
    type: zRfpOccurrenceTypeEnum.optional()
}));

/**
 * Indicates dollar amount of available reimbursement for member completing wellness initiative(s).
 */
export const zRfpWellnessBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

export const zRfpWellnessBenefit = zBaseWellnessBenefit.and(z.object({
    type: zRfpWellnessBenefitTypeEnum.optional()
}));

/**
 * The limiting age for a child to receive ortho coverage.
 */
export const zBaseOrthoAgeLimit = z.object({
    age: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * The object type for dental benefits.
 */
export const zDentalObjectTypeEnum = z.enum(['dental']);

export const zDhmoBenefitDetail = z.object({
    adaCode: z.string().max(256).regex(/^[^\x00-\x1F\x7F]*$/),
    serviceName: z.string().max(256).regex(/^[^\x00-\x1F\x7F]*$/).optional(),
    memberCost: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))
});

/**
 * The dollar amount when applicable. Omit if not applicable.
 */
export const zDollarAmount = z.number().gte(0);

/**
 * Indicates the type of dollar amount for individual deductible.
 */
export const zIndividualDeductibleEnum = z.enum(['dollarAmount']);

export const zIndividualDeductibleBenefit = z.object({
    amount: zDollarAmount.optional(),
    type: zIndividualDeductibleEnum
});

/**
 * The percentage amount when applicable. Must be between 0-100. Omit if not applicable.
 */
export const zPercentageAmount = z.number().gte(0).lte(100);

/**
 * This is a list of categories for dental services for RFP.
 */
export const zRfpDentalServiceCategoryEnum = z.enum([
    'preventive',
    'basic',
    'major',
    'notIncluded'
]);

/**
 * Indicates the type of dollar amount for RFP.
 */
export const zRfpDollarBenefitEnum = z.enum([
    'dollarAmount',
    'dollarAmountPerPerson',
    'notIncluded'
]);

export const zRfpDollarBenefit = z.object({
    amount: zDollarAmount.optional(),
    type: zRfpDollarBenefitEnum
});

/**
 * The type of ortho age limit for RFP.
 */
export const zRfpOrthoAgeLimitTypeEnum = z.enum([
    'childrenOnlyToAge',
    'adultAndChildren',
    'childrenOnlyAgeNotDisclosed',
    'notApplicable',
    'notIncluded'
]);

export const zRfpOrthoAgeLimit = zBaseOrthoAgeLimit.and(z.object({
    type: zRfpOrthoAgeLimitTypeEnum
}));

/**
 * Indicates the type of percentage amount for RFP.
 */
export const zRfpPercentageBenefitTypeEnum = z.enum(['percentageAmount', 'notIncluded']);

export const zRfpPercentageBenefit = z.object({
    amount: zPercentageAmount.optional(),
    type: zRfpPercentageBenefitTypeEnum
});

/**
 * The type of dental service for which the waiting period applies.
 */
export const zServiceWaitingPeriodTypeEnum = z.enum([
    'preventive',
    'basic',
    'major',
    'ortho',
    'sealants',
    'spaceMaintainers',
    'generalAnesthesia',
    'compositeWhiteFillings',
    'endodontics',
    'periodonticsSurgical',
    'periodonticsNonSurgical',
    'oralSurgerySimple',
    'oralSurgeryComplex',
    'implants'
]);

export const zServiceWaitingPeriod = z.object({
    type: zServiceWaitingPeriodTypeEnum,
    months: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(24))
});

/**
 * The object type for EAP benefits.
 */
export const zEapObjectTypeEnum = z.enum(['eap']);

/**
 * Indicates which product the EAP is tied to for RFP.
 */
export const zRfpTiedToAnotherLocEnum = z.enum([
    'shortTermDisability',
    'longTermDisability',
    'basicLifeAdnd',
    'voluntaryLifeAdnd',
    'notIncluded',
    'notTied'
]);

/**
 * Object type identifier for FML benefits.
 */
export const zFmlObjectTypeEnum = z.enum(['fml']);

export const zBaseFmlBenefit = z.object({
    objectType: zFmlObjectTypeEnum,
    historyAndTakeover: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    companyLeaves: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    correspondence: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional()
});

/**
 * The type of coverage for RFP.
 */
export const zRfpFmlBenefitTypeEnum = z.enum([
    'additionalDollarAmount',
    'includedInBasePrice',
    'notIncluded'
]);

export const zRfpFlmBenefitType = z.object({
    type: zRfpFmlBenefitTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Confirms if the plan is integrated with disability for RFP.
 */
export const zRfpIntegratedStdFmlaClaimIntakeEnum = z.enum(['included', 'notIncluded']);

export const zRfpFmlBenefit = zBaseFmlBenefit.and(z.object({
    federalFmla: zRfpFlmBenefitType.optional(),
    unpaidStateLeaves: zRfpFlmBenefitType.optional(),
    militaryUserra: zRfpFlmBenefitType.optional(),
    juryDuty: zRfpFlmBenefitType.optional(),
    ada: zRfpFlmBenefitType.optional(),
    integratedStdFmlaClaimIntake: zRfpIntegratedStdFmlaClaimIntakeEnum.optional()
}));

/**
 * The object type for individual disability benefits.
 */
export const zIndividualDisabilityObjectTypeEnum = z.enum(['individualDisability']);

/**
 * Indicates the benefit allowed for a catastrophic benefit for RFP.
 */
export const zRfpCatastrophicBenefitEnum = z.enum([
    'percentageAmount',
    'included',
    'notIncluded'
]);

/**
 * Describes the IDI plan design type for RFP.
 */
export const zRfpIdiPlanDesignTypeEnum = z.enum([
    'percentage',
    'percentageToDollarAmount',
    'notIncluded'
]);

/**
 * The mental illness benefit type for RFP.
 */
export const zRfpIndividualDisabilityMentalIllnessBenefitTypeEnum = z.enum([
    'years',
    'months',
    'noLimit',
    'payableSameAsAnyOtherDisability',
    'included',
    'notIncluded'
]);

/**
 * The type of own occupation period for RFP.
 */
export const zRfpIndividualDisabilityOwnOccupationPeriodTypeEnum = z.enum([
    'yearsOwnOccupation',
    'monthsOwnOccupation',
    'ownOccupationOnly',
    'notIncluded'
]);

/**
 * Indicates if policy holder can continue policy after separation of employment for RFP.
 */
export const zRfpIndividualDisabilityPortabilityEnum = z.enum(['included', 'notIncluded']);

/**
 * Describes the LTD plan design type for RFP.
 */
export const zRfpLtdPlanDesignTypeEnum = z.enum([
    'increments',
    'percentageToDollarAmount',
    'notIncluded'
]);

/**
 * Indicates if a recovery benefit is included in the IDI offering for RFP.
 */
export const zRfpRecoveryBenefitEnum = z.enum([
    'dollarAmount',
    'included',
    'notIncluded'
]);

/**
 * Indicates the period of time after participant becomes disabled that must pass before they begin receiving benefit.
 */
export const zEliminationPeriod = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Defines the carrier's required 'loss of earnings' that must be met to be eligible for benefit.
 */
export const zGainfulEarningsTest = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).lte(100).optional()
});

/**
 * Indicates the total benefit that is guaranteed without health questions.
 */
export const zGuaranteedIssue = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Base type for time period limitations.
 */
export const zLimitation = z.object({
    type: z.unknown(),
    timeframe: z.number().gte(0).optional()
});

/**
 * Object type identifier for LTD benefits.
 */
export const zLtdObjectTypeEnum = z.enum(['ltd']);

/**
 * Indicates the own occupation period structure.
 */
export const zOwnOccupationPeriod = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * The type of gainful earnings test for RFP.
 */
export const zRfpGainfulEarningsRuleTypeEnum = z.enum([
    'percentage',
    'notApplicable',
    'notIncluded'
]);

export const zRfpGainfulEarningsTest = zGainfulEarningsTest.and(z.object({
    type: zRfpGainfulEarningsRuleTypeEnum.optional()
}));

/**
 * The type of benefit amount structure.
 */
export const zRfpLtdBenefitAmountTypeEnum = z.enum([
    'increments',
    'flatAmount',
    'percentageOfSalary'
]);

/**
 * Indicates the percentage of salary benefit will pay or the increments at which the benefits can be elected.
 */
export const zLtdBenefitAmount = z.object({
    type: zRfpLtdBenefitAmountTypeEnum,
    amount: z.number().gte(0).optional(),
    minimum: z.number().gte(0).optional()
});

/**
 * The type of guaranteed issue structure for RFP.
 */
export const zRfpLtdGuaranteedIssueRuleTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

export const zRfpGuaranteedIssue = zGuaranteedIssue.and(z.object({
    type: zRfpLtdGuaranteedIssueRuleTypeEnum.optional()
}));

/**
 * The type of time period limitation for RFP.
 */
export const zRfpLtdLimitationTypeEnum = z.enum([
    'years',
    'months',
    'noLimit',
    'payableSameAsAnyOtherDisability',
    'included',
    'notIncluded'
]);

export const zRfpLimitation = zLimitation.and(z.object({
    type: zRfpLtdLimitationTypeEnum.optional()
}));

/**
 * Indicates if additional plan limitations exist.
 */
export const zRfpLtdOtherLimitationsEnum = z.enum([
    'years',
    'months',
    'noLimit',
    'payableSameAsAnyOtherDisability',
    'included',
    'notIncluded'
]);

/**
 * The type of own occupation period for RFP.
 */
export const zRfpLtdOwnOccupationPeriodTypeEnum = z.enum([
    'yearsOwnOccupation',
    'monthsOwnOccupation',
    'ownOccupationOnly',
    'notIncluded'
]);

export const zRfpOtherLimitation = zLimitation.and(z.object({
    type: zRfpLtdOtherLimitationsEnum.optional()
}));

export const zRfpOwnOccupationPeriod = zOwnOccupationPeriod.and(z.object({
    type: zRfpLtdOwnOccupationPeriodTypeEnum.optional()
}));

/**
 * Defines the carrier rehabilitation requirement to be eligible for benefit.
 */
export const zRfpRehabTypeEnum = z.enum([
    'mandatory',
    'mandatoryWithEnhanced',
    'voluntary',
    'voluntaryWithEnhanced',
    'enhanced',
    'notIncluded'
]);

/**
 * Indicates the maximum amount of time the carrier will pay out the benefit.
 */
export const zRfpStdBenefitDurationTypeEnum = z.enum([
    'days',
    'weeks',
    'notIncluded'
]);

/**
 * Indicates the maximum amount of time the carrier will pay out the benefit minus the elimination period time.
 */
export const zRfpStdBenefitDuration = z.object({
    type: zRfpStdBenefitDurationTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the percentage of salary benefit will pay or the increment at which benefits may be elected.
 */
export const zStdBenefitAmountTypeEnum = z.enum([
    'increments',
    'flatAmount',
    'percentageOfSalary'
]);

/**
 * Indicates the percentage of salary benefit will pay or the increment at which benefits may be elected.
 */
export const zStdBenefitAmount = z.object({
    type: zStdBenefitAmountTypeEnum,
    amount: z.number().gte(0).optional(),
    minimum: z.number().gte(0).optional()
});

/**
 * Object type identifier for STD benefits.
 */
export const zStdObjectTypeEnum = z.enum(['std']);

export const zBaseFramesDiscountsRule = z.object({
    amount: z.number().gte(0).optional()
});

export const zBaseVisionNetworkBenefit = z.object({
    networkName: z.string().max(100000).regex(/^[^\x00-\x1F\x7F]*$/).optional()
});

/**
 * The type of frames discount that applies for RFP.
 */
export const zRfpFramesDiscountsRuleTypeEnum = z.enum([
    'upToPercentageOff',
    'upToDollarAmountOff',
    'notIncluded'
]);

export const zRfpFramesDiscountsRule = z.object({
    type: zRfpFramesDiscountsRuleTypeEnum
}).and(zBaseFramesDiscountsRule);

/**
 * Indicates the frequency at which the service can be rendered.
 */
export const zRfpVisionBenefitFrequencyOptionEnum = z.enum([
    'twelve',
    'twentyFour',
    'calendarYear',
    'everyOtherCalendarYear',
    'notIncluded'
]);

/**
 * The type of copay rule for progressive lenses and contact lens exams for RFP.
 */
export const zRfpVisionCopayAllowanceRuleTypeEnum = z.enum([
    'coveredInFullAfterCopay',
    'dollarAmountAllowance',
    'dollarAmountAllowanceWithoutCopay',
    'dollarAmountAllowanceWithCopay',
    'notIncluded'
]);

/**
 * Indicates the portion of cost covered by carrier after copay has been met for progressive lenses and contact lens exams.
 */
export const zRfpVisionCopayAllowanceRule = z.object({
    type: zRfpVisionCopayAllowanceRuleTypeEnum,
    copayAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    allowanceAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * The type of copay rule that applies to network benefits for RFP.
 */
export const zRfpVisionCopayFullAllowanceRuleTypeEnum = z.enum([
    'coveredInFullAfterCopay',
    'coveredInFull',
    'dollarAmountAllowance',
    'dollarAmountAllowanceWithCopay',
    'notIncluded'
]);

/**
 * Indicates the portion of cost covered by carrier after copay has been met.
 */
export const zRfpVisionCopayFullAllowanceRule = z.object({
    type: zRfpVisionCopayFullAllowanceRuleTypeEnum,
    copayAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    allowanceAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * The type of copay rule that applies for RFP.
 */
export const zRfpVisionCopayRuleTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

/**
 * The type of copay rule for specific vision services for RFP.
 */
export const zRfpVisionSpecialCopayAllowanceRuleTypeEnum = z.enum([
    'dollarAmountAllowance',
    'dollarAmountAllowanceWithoutCopay',
    'dollarAmountAllowanceWithCopay',
    'notIncluded'
]);

/**
 * Indicates the portion of cost covered by carrier after copay has been met for specific vision services.
 */
export const zRfpVisionSpecialCopayAllowanceRule = z.object({
    type: zRfpVisionSpecialCopayAllowanceRuleTypeEnum,
    copayAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    allowanceAmount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

export const zVisionCopayRule = z.object({
    amount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

export const zRfpVisionCopayRule = z.object({
    type: zRfpVisionCopayRuleTypeEnum
}).and(zVisionCopayRule);

/**
 * The object type for vision benefits.
 */
export const zVisionObjectTypeEnum = z.enum(['vision']);

/**
 * The unit of measurement for child benefit age band limits.
 */
export const zChildBenefitAgeUnitEnum = z.enum([
    'days',
    'months',
    'years'
]);

/**
 * Age-based guarantee issue amounts.
 */
export const zGuaranteeIssueAgeBasedAmount = z.object({
    ageBandLower: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    ageBandUpper: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    amount: z.number().gte(0)
});

/**
 * Indicates if AD&D benefit amount must match vol life benefit amount.
 */
export const zRfpVoluntaryLifeAdndTiedToLifeTypeEnum = z.enum([
    'tied',
    'untied',
    'clientLevelDecision'
]);

/**
 * Indicates the type of age reduction schedule.
 */
export const zRfpVoluntaryLifeAgeReductionScheduleTypeEnum = z.enum(['percentageAtAge', 'notIncluded']);

/**
 * Indicates limitation on Spouse or Child benefit.
 */
export const zRfpVoluntaryLifeAmountNotToExceedTypeEnum = z.enum([
    'percentageOfEmployeeElection',
    'notApplicable',
    'notIncluded'
]);

/**
 * Amount not to exceed configuration.
 */
export const zRfpVoluntaryLifeAmountNotToExceed = z.object({
    type: zRfpVoluntaryLifeAmountNotToExceedTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the maximum amount of benefit that can be elected.
 */
export const zRfpVoluntaryLifeBenefitMaximumTypeEnum = z.enum([
    'dollarAmount',
    'salaryMultiplier',
    'lesserOfDollarAmountOrSalaryMultiplier'
]);

/**
 * Benefit maximum configuration.
 */
export const zRfpVoluntaryLifeBenefitMaximum = z.object({
    type: zRfpVoluntaryLifeBenefitMaximumTypeEnum,
    dollarAmount: z.number().gte(0).optional(),
    salaryMultiplier: z.number().gte(0).optional()
});

/**
 * Describes the benefit configuration available for employee.
 */
export const zRfpVoluntaryLifeEmployeeBenefitTypeEnum = z.enum([
    'increments',
    'dollarAmount',
    'multipleOptions',
    'salaryMultiplier'
]);

/**
 * Describes the benefit configuration available for employee.
 */
export const zRfpVoluntaryLifeEmployeeBenefitAmount = z.object({
    type: zRfpVoluntaryLifeEmployeeBenefitTypeEnum,
    amounts: z.array(z.number().gte(0)).max(100000).optional()
});

/**
 * Indicates the amount of Life Insurance volume available without having to provide Evidence of Insurability.
 */
export const zRfpVoluntaryLifeGuaranteeIssueTypeEnum = z.enum([
    'dollarAmount',
    'ageBasedAmounts',
    'salaryMultiplierWithCap',
    'salaryMultiplierWithDollarAmountPlusAdditionalAmount',
    'allGuaranteeIssue',
    'notIncluded'
]);

/**
 * Guarantee issue configuration.
 */
export const zRfpVoluntaryLifeGuaranteeIssue = z.object({
    type: zRfpVoluntaryLifeGuaranteeIssueTypeEnum,
    dollarAmount: z.number().gte(0).optional(),
    salaryMultiplier: z.number().gte(0).optional(),
    additionalAmount: z.number().gte(0).optional(),
    ageBasedAmounts: z.array(zGuaranteeIssueAgeBasedAmount).max(100000).optional()
});

/**
 * Employee voluntary life benefit configuration.
 */
export const zRfpVoluntaryLifeEmployeeBenefit = z.object({
    benefitDescription: zRfpVoluntaryLifeEmployeeBenefitAmount,
    benefitMaximum: zRfpVoluntaryLifeBenefitMaximum.optional(),
    guaranteeIssue: zRfpVoluntaryLifeGuaranteeIssue.optional()
});

/**
 * Indicates the maximum amount of benefit that can be elected for spouse and child.
 */
export const zRfpVoluntaryLifeSpouseChildBenefitMaximumTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

/**
 * Benefit maximum configuration for spouse and child.
 */
export const zRfpVoluntaryLifeSpouseChildBenefitMaximum = z.object({
    type: zRfpVoluntaryLifeSpouseChildBenefitMaximumTypeEnum,
    dollarAmount: z.number().gte(0).optional()
});

/**
 * Describes the benefit configuration available for spouse and child.
 */
export const zRfpVoluntaryLifeSpouseChildBenefitTypeEnum = z.enum([
    'increments',
    'dollarAmount',
    'multipleOptions',
    'percentageOfEmployeeElection',
    'notIncluded'
]);

/**
 * Describes the benefit configuration available for spouse and child.
 */
export const zRfpVoluntaryLifeSpouseChildBenefitAmount = z.object({
    type: zRfpVoluntaryLifeSpouseChildBenefitTypeEnum,
    amounts: z.array(z.number().gte(0)).max(100000).optional()
});

/**
 * Child benefit configuration for a specific age band.
 */
export const zChildBenefitAgeBasedAmount = z.object({
    ageBandLower: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    ageBandUpper: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    unit: zChildBenefitAgeUnitEnum,
    benefitAmount: zRfpVoluntaryLifeSpouseChildBenefitAmount
});

/**
 * Child benefit configuration by age bands.
 */
export const zRfpVoluntaryLifeChildBenefitByAge = z.array(zChildBenefitAgeBasedAmount).max(100000);

/**
 * Spouse voluntary life benefit configuration.
 */
export const zRfpVoluntaryLifeSpouseBenefit = z.object({
    benefitDescription: zRfpVoluntaryLifeSpouseChildBenefitAmount,
    benefitMaximum: zRfpVoluntaryLifeSpouseChildBenefitMaximum.optional(),
    guaranteeIssue: zRfpVoluntaryLifeGuaranteeIssue.optional(),
    amountNotToExceed: zRfpVoluntaryLifeAmountNotToExceed.optional()
});

/**
 * Indicates if the child benefits are offered beyond the child limiting age for children who are full time students.
 */
export const zRfpVoluntaryLifeStudentStatusTypeEnum = z.enum(['included', 'notIncluded']);

/**
 * Student status configuration.
 */
export const zRfpVoluntaryLifeStudentStatus = z.object({
    type: zRfpVoluntaryLifeStudentStatusTypeEnum,
    amount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Child voluntary life benefit configuration.
 */
export const zRfpVoluntaryLifeChildBenefit = z.object({
    benefitAmountsByAge: zRfpVoluntaryLifeChildBenefitByAge,
    benefitMaximum: zRfpVoluntaryLifeSpouseChildBenefitMaximum.optional(),
    amountNotToExceed: zRfpVoluntaryLifeAmountNotToExceed.optional(),
    studentLimitingAge: zRfpVoluntaryLifeStudentStatus.optional()
});

/**
 * Describes the dependent benefit configuration available for RFP.
 */
export const zRfpDependentBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

/**
 * Indicates the amount of benefit available for a dependent.
 */
export const zRfpDependentBenefit = z.object({
    type: zRfpDependentBenefitTypeEnum,
    amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Indicates when the plan will be initiated for RFP.
 */
export const zRfpWholeLifeCoverageEffectiveDateEnum = z.enum([
    'firstOfTheMonthFollowingEffectiveDate',
    'firstOfTheMonthFollowingSignedApplication',
    'firstDayOfTheMonthInWhichPayrollDeductionsBegin',
    'coverageIsEffectiveOnThePolicyDate',
    'dateOfSignedApplication',
    'notIncluded'
]);

/**
 * Indicates the type of coverage provided by the whole life plan.
 */
export const zWholeLifeCoverageTypeEnum = z.enum([
    'faceValue',
    'cashValue',
    'moneyPurchase'
]);

/**
 * Describes the benefit configuration available.
 */
export const zWholeLifeEmployeeBenefitAmountTypeEnum = z.enum([
    'increments',
    'dollarAmount',
    'multipleOptions',
    'salaryMultiplier'
]);

/**
 * Indicates the maximum amount of benefit that can be elected.
 */
export const zWholeLifeEmployeeBenefitMaximumTypeEnum = z.enum([
    'dollarAmount',
    'salaryMultiplier',
    'lesserOfDollarAmountOrSalaryMultiplier',
    'notIncluded'
]);

/**
 * The object type for whole life benefits.
 */
export const zWholeLifeObjectTypeEnum = z.enum(['wholeLife']);

export const zBaseWholeLifeBenefit = z.object({
    objectType: zWholeLifeObjectTypeEnum,
    coverageType: zWholeLifeCoverageTypeEnum.optional(),
    employeeBenefitAmount: z.object({
        type: zWholeLifeEmployeeBenefitAmountTypeEnum,
        amount: z.array(z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))).max(100000)
    }).optional(),
    employeeBenefitMaximum: z.object({
        type: zWholeLifeEmployeeBenefitMaximumTypeEnum,
        dollarAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
        salaryMultiplier: z.number().gte(1).optional()
    }).optional(),
    guaranteeIssueAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
    ridersIncluded: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    additionalOptionsIncluded: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    interestRate: z.number().gte(0).optional(),
    endowsAge: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
});

/**
 * Type of commission paid to a Producer.
 */
export const zCommissionTypeEnum = z.enum([
    'heaped',
    'percentage',
    'standard',
    'graded',
    'net',
    'pepm'
]);

/**
 * Type of commission the carrier returned for a proposal plan. Extends
 * the canonical commission type with `notDisclosed` and `notApplicable`,
 * which are schema-level extensions and not part of the canonical enum.
 *
 */
export const zProposalsProposalCommissionType = z.union([
    zCommissionTypeEnum,
    z.enum(['notDisclosed', 'notApplicable'])
]);

export const zProposalsUpdateProposalCommissionRequest = z.object({
    returnedType: zProposalsProposalCommissionType,
    returnedAmount: z.number().nullish(),
    returnedHeapedAmount: z.array(z.number()).nullish()
});

/**
 * Details for a benefit amount including type and amount.
 */
export const zBenefitAmountDetails = z.object({
    type: z.unknown(),
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the maximum amount of time the carrier will pay out the benefit.
 */
export const zBenefitDurationTypeEnum = z.enum([
    'ssnra',
    'ssnraWithRbd',
    'rbdWithSsnra',
    'adea1WithSsnra',
    'adea1',
    'adea2',
    'adea3',
    'adea4',
    'twoYearAdea',
    'threeYearAdea',
    'fiveYearAdea',
    'tenYearAdeaSchedule',
    'reducingBenefitDuration',
    'ssAdea',
    'toAge65',
    'toAge67',
    'laterOfAgeOrSsnra',
    'lesserOfRbdOrNumberOfYears',
    'yearDuration',
    'notIncluded'
]);

/**
 * Indicates the amount of time the carrier will pay out the benefit.
 */
export const zBenefitDuration = z.object({
    type: zBenefitDurationTypeEnum,
    amount: z.number().gte(0).optional()
});

/**
 * Indicates the maximum amount of benefit that can be elected.
 */
export const zBenefitMaximumTypeEnum = z.enum([
    'dollarAmount',
    'salaryMultiplier',
    'lesserOfDollarAmountOrSalaryMultiplier'
]);

/**
 * Indicates carrier defined requirements for what constitutes a disability.
 */
export const zDefinitionOfDisabilityTypeEnum = z.enum([
    'lossOfDuties',
    'lossOfEarnings',
    'lossOfEarningsAndDuties',
    'lossOfEarningsOrLossOfDuties'
]);

/**
 * Defines the carrier's definition of earnings for the purpose of calculating benefit amount.
 */
export const zDefinitionOfEarningsTypeEnum = z.enum([
    'salary',
    'salaryPlusCommissions',
    'salaryPlusBonus',
    'salaryPlusBonusPlusCommissions',
    'priorYearW2',
    'k1',
    'notApplicable',
    'notIncluded'
]);

/**
 * Indicates the earnings covered by the plan.
 */
export const zDefinitionOfEarnings = z.object({
    type: zDefinitionOfEarningsTypeEnum,
    averageMonth: z.number().gte(1).optional()
});

/**
 * Indicates the period of time that must pass before they begin receiving benefit.
 */
export const zEliminationPeriodType = z.object({
    amount: z.number().gte(0).optional()
});

/**
 * The level of Employer contribution.
 */
export const zEmployerContributionEnum = z.enum([
    'oneHundredPercentEmployerPaid',
    'contributory',
    'voluntary',
    'bonusUp',
    'grossUp',
    'taxChoice',
    'notIncluded'
]);

export const zBaseDentalBenefit = z.object({
    objectType: zDentalObjectTypeEnum,
    serviceWaitingPeriods: z.array(zServiceWaitingPeriod).max(100000).optional(),
    dependentAgeLimitYears: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(33)).optional(),
    dhmoBenefits: z.array(zDhmoBenefitDetail).max(100000).optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zBaseEapBenefit = z.object({
    objectType: zEapObjectTypeEnum,
    faceToFaceVisits: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    perOccurrencePerYear: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    legalFinancialResources: z.string().max(4096).regex(/^[^\x00-\x08\x0E-\x1F\x7F]*$/).optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zBaseIndividualDisabilityBenefit = z.object({
    objectType: zIndividualDisabilityObjectTypeEnum,
    benefitDuration: zBenefitDuration.optional(),
    definitionOfDisability: zDefinitionOfDisabilityTypeEnum.optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zInNetworkOnlyEnum = z.enum(['inNetwork']);

export const zRfpVisionNetworkBenefit = z.object({
    network: zInNetworkOnlyEnum.optional()
}).and(zBaseVisionNetworkBenefit).and(z.object({
    examCopay: zRfpVisionCopayRule.optional(),
    materialsCopay: zRfpVisionCopayRule.optional(),
    singleLenses: zRfpVisionCopayFullAllowanceRule.optional(),
    bifocalLenses: zRfpVisionCopayFullAllowanceRule.optional(),
    trifocalLenses: zRfpVisionCopayFullAllowanceRule.optional(),
    lenticularLenses: zRfpVisionCopayFullAllowanceRule.optional(),
    standardProgressive: zRfpVisionCopayAllowanceRule.optional(),
    standardFrames: zRfpVisionSpecialCopayAllowanceRule.optional(),
    additionalDiscountsOnFrames: zRfpFramesDiscountsRule.optional(),
    contactLensElective: zRfpVisionSpecialCopayAllowanceRule.optional(),
    contactLensExam: zRfpVisionCopayAllowanceRule.optional()
}));

/**
 * Indicates the total max dollar amount benefit will pay.
 */
export const zMaximumAmountType = z.object({
    type: z.unknown(),
    dollarAmount: z.number().gte(0).optional(),
    percent: z.number().gte(0).optional()
});

/**
 * Indicates the total max dollar amount benefit will pay.
 */
export const zMaximumAmountTypeEnum = z.enum([
    'dollarAmount',
    'dollarAmountNotToExceedPercentageOfPredisabilityEarnings',
    'unlimited'
]);

export const zDisabilityMaximumAmount = zMaximumAmountType.and(z.object({
    type: zMaximumAmountTypeEnum.optional()
}));

export const zBaseLtdBenefit = z.object({
    objectType: zLtdObjectTypeEnum,
    benefitAmount: zLtdBenefitAmount.optional(),
    maximumAmount: zDisabilityMaximumAmount.optional(),
    definitionOfDisability: zDefinitionOfDisabilityTypeEnum.optional(),
    definitionOfEarnings: zDefinitionOfEarnings.optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zBaseStdBenefit = z.object({
    objectType: zStdObjectTypeEnum,
    benefitAmount: zStdBenefitAmount.optional(),
    maximumAmount: zDisabilityMaximumAmount.optional(),
    definitionOfDisability: zDefinitionOfDisabilityTypeEnum.optional(),
    definitionOfEarnings: zDefinitionOfEarnings.optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

/**
 * This indicates if a benefit/service is considered as in network or out of network.
 */
export const zNetworkEnum = z.enum(['inNetwork', 'outOfNetwork']);

export const zBaseDentalNetworkBenefit = z.object({
    network: zNetworkEnum,
    networkName: z.string().max(100000).regex(/^[^\x00-\x1F\x7F]*$/).optional(),
    individualDeductible: zIndividualDeductibleBenefit.optional()
});

export const zRfpDentalNetworkBenefit = zBaseDentalNetworkBenefit.and(z.object({
    familyDeductible: zRfpDollarBenefit.optional(),
    annualMaximum: zRfpDollarBenefit.optional(),
    preventativeType1: zRfpPercentageBenefit.optional(),
    basicType2: zRfpPercentageBenefit.optional(),
    majorType3: zRfpPercentageBenefit.optional(),
    orthoType4: zRfpPercentageBenefit.optional(),
    orthoMaximum: zRfpDollarBenefit.optional(),
    endodontics: zRfpDentalServiceCategoryEnum.optional(),
    periodonticsNonSurgical: zRfpDentalServiceCategoryEnum.optional(),
    periodonticsSurgical: zRfpDentalServiceCategoryEnum.optional(),
    oralSurgerySimple: zRfpDentalServiceCategoryEnum.optional(),
    oralSurgeryComplex: zRfpDentalServiceCategoryEnum.optional(),
    implants: zRfpDentalServiceCategoryEnum.optional(),
    sealants: zRfpDentalServiceCategoryEnum.optional(),
    spaceMaintainers: zRfpDentalServiceCategoryEnum.optional(),
    generalAnesthesia: zRfpDentalServiceCategoryEnum.optional(),
    compositeWhiteFillings: zRfpDentalServiceCategoryEnum.optional(),
    orthoAgeLimit: zRfpOrthoAgeLimit.optional()
}));

/**
 * This is the list values expected for Out of Network Reimbursement for RFP.
 */
export const zOutOfNetworkReimbursementEnum = z.enum([
    '45thUcr',
    '50thUcr',
    '51stUcr',
    '70thUcr',
    '75thUcr',
    '80thUcr',
    '85thUcr',
    '90thUcr',
    '95thUcr',
    '99thUcr',
    'mac',
    'mpa',
    'feeSchedule',
    'notIncluded'
]);

export const zReductionDetails = z.object({
    ageBandLower: z.coerce.bigint().gte(BigInt(-9007199254740991)).lte(BigInt(9007199254740991)).optional(),
    ageBandUpper: z.coerce.bigint().gte(BigInt(-9007199254740991)).lte(BigInt(9007199254740991)).optional(),
    percent: z.number()
});

export const zBenefitPlansVoluntaryLifeAdndExtendedBenefit = z.object({
    eligibilityHours: z.string().nullish(),
    suicideExclusion: z.string().nullish(),
    waiverOfPremiumEligibility: z.string().nullish(),
    waiverOfPremiumWaitingPeriod: z.string().nullish(),
    waiverOfPremiumDuration: z.string().nullish(),
    airBag: z.string().nullish(),
    commonCarrier: z.string().nullish(),
    repatriation: z.string().nullish(),
    seatBelt: z.string().nullish(),
    annualAbilityToIncreaseBenefit: z.string().nullish(),
    spouseAgeBasis: z.string().nullish(),
    employeeAgeReductionScheduleType: z.string().nullish(),
    employeeAgeReductionSchedules: z.array(zReductionDetails).nullish(),
    spouseAgeReductionScheduleType: z.string().nullish(),
    spouseAgeReductionSchedules: z.array(zReductionDetails).nullish()
});

/**
 * This is the list of reductions
 */
export const zReductionSchedule = z.array(zReductionDetails).max(100000);

/**
 * Age reduction schedule configuration.
 */
export const zRfpVoluntaryLifeAgeReductionSchedule = z.object({
    type: zRfpVoluntaryLifeAgeReductionScheduleTypeEnum,
    schedules: zReductionSchedule.optional()
});

/**
 * Details any benefit change-increments based on age. (Ex: 35% at 65, 50% at 70 *standard is two, but could be up to 6).
 */
export const zBaseAgeReductionSchedule = z.object({
    type: z.unknown(),
    schedules: zReductionSchedule.optional()
});

/**
 * Indicates the type of age reduction schedule for RFP.
 */
export const zRfpAgeReductionScheduleTypeEnum = z.enum(['percentageAtAge', 'notIncluded']);

export const zRfpAgeReductionSchedule = zBaseAgeReductionSchedule.and(z.object({
    type: zRfpAgeReductionScheduleTypeEnum.optional()
}));

/**
 * The type of annual open enrollment for the plan.
 */
export const zRfpAnnualOpenEnrollmentEnum = z.enum([
    'oneTimeOpenEnrollment',
    'annualOpenEnrollment',
    'modifiedOpenEnrollment',
    'included',
    'notIncluded'
]);

export const zRfpVisionBenefit = z.object({
    objectType: zVisionObjectTypeEnum,
    networkBenefits: z.array(zRfpVisionNetworkBenefit).max(100000).optional(),
    examFrequency: zRfpVisionBenefitFrequencyOptionEnum.optional(),
    lensesFrequency: zRfpVisionBenefitFrequencyOptionEnum.optional(),
    framesFrequency: zRfpVisionBenefitFrequencyOptionEnum.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zBenefitPlansRfpVisionBenefitWithExtended = zRfpVisionBenefit.and(z.object({
    extended: zBenefitPlansVisionExtendedBenefit.optional()
}));

/**
 * Indicates dollar amount carrier will cover as benefit for this service, including any conditional requirements.
 */
export const zRfpBenefitTypeEnum = z.enum(['dollarAmount', 'notIncluded']);

export const zRfpBenefitAmountDetails = zBenefitAmountDetails.and(z.object({
    type: zRfpBenefitTypeEnum.optional()
}));

/**
 * Indicates if the FICA match is considered billable or non-billable.
 */
export const zRfpBillableTypeEnum = z.enum([
    'billable',
    'nonBillable',
    'notApplicable',
    'notIncluded'
]);

/**
 * This is the list of deductible time periods.
 */
export const zRfpDeductibleDurationEnum = z.enum([
    'calendarYear',
    'lifetime',
    'notIncluded'
]);

/**
 * Indicates the period of time that must pass before they begin receiving benefit.
 */
export const zRfpEliminationPeriodTypeEnum = z.enum(['days', 'notIncluded']);

export const zRfpEliminationPeriod = zEliminationPeriod.and(z.object({
    type: zRfpEliminationPeriodTypeEnum.optional()
}));

export const zRfpEliminationPeriodType = zEliminationPeriodType.and(z.object({
    type: zRfpEliminationPeriodTypeEnum
}));

/**
 * Indicates if FICA match is included.
 */
export const zRfpFicaMatchEnum = z.enum(['included', 'notIncluded']);

/**
 * Indicates the inclusion status of a benefit or feature.
 */
export const zRfpInclusionStatusEnum = z.enum(['included', 'notIncluded']);

export const zRfpAccidentBenefit = z.object({
    objectType: z.enum(['accident']),
    coverageType: zRfpAccidentCoverageTypeEnum.optional(),
    hospitalAdmission: zRfpAccidentSpecificBenefitDetails.optional(),
    icuAdmission: zRfpAccidentBenefitDetails.optional(),
    dailyHospitalConfinement: zRfpAccidentSpecificBenefitDetails.optional(),
    dailyIcuConfinement: zRfpAccidentBenefitDetails.optional(),
    ambulanceAir: zRfpAccidentSpecificBenefitDetails.optional(),
    ambulanceGround: zRfpAccidentSpecificBenefitDetails.optional(),
    emergencyTreatment: zRfpAccidentSpecificBenefitDetails.optional(),
    urgentCare: zRfpAccidentSpecificBenefitDetails.optional(),
    initialPhysicianOfficeVisit: zRfpAccidentSpecificBenefitDetails.optional(),
    dislocationsMaximum: zRfpAccidentMaxBenefitDetails.optional(),
    fracturesMaximum: zRfpAccidentMaxBenefitDetails.optional(),
    lacerationsMaximum: zRfpAccidentMaxBenefitDetails.optional(),
    coma: zRfpAccidentMaxBenefitDetails.optional(),
    majorDiagnosticExamXray: zRfpAccidentMaxBenefitDetails.optional(),
    majorDiagnosticExamMri: zRfpAccidentMaxBenefitDetails.optional(),
    wellnessBenefit: zRfpBenefitAmountDetails.optional(),
    childOrganizedSportsEnhancement: zRfpInclusionStatusEnum.optional(),
    portability: zRfpInclusionStatusEnum.optional(),
    ageReductionSchedule: zRfpAgeReductionSchedule.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional()
});

export const zBenefitPlansRfpAccidentBenefitWithExtended = zRfpAccidentBenefit.and(z.object({
    extended: zBenefitPlansAccidentExtendedBenefit.optional()
}));

export const zRfpDentalBenefit = zBaseDentalBenefit.and(z.object({
    networkBenefits: z.array(zRfpDentalNetworkBenefit).max(100000).optional(),
    outOfNetworkReimbursement: zOutOfNetworkReimbursementEnum.optional(),
    maximumRollover: zRfpInclusionStatusEnum.optional(),
    missingToothExclusion: zRfpInclusionStatusEnum.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional(),
    deductibleDuration: zRfpDeductibleDurationEnum.optional(),
    isDeductibleWaivedPreventative: zRfpInclusionStatusEnum.optional()
}));

export const zBenefitPlansRfpDentalBenefitWithExtended = zRfpDentalBenefit.and(z.object({
    extended: zBenefitPlansDentalExtendedBenefit.optional()
}));

export const zRfpEapBenefit = zBaseEapBenefit.and(z.object({
    unlimitedTelephonic: zRfpInclusionStatusEnum.optional(),
    tiedToAnotherLoc: zRfpTiedToAnotherLocEnum.optional()
}));

export const zRfpWholeLifeBenefit = zBaseWholeLifeBenefit.and(z.object({
    spouseBenefitAmount: zRfpDependentBenefit.optional(),
    spouseBenefitMaximum: zRfpDependentBenefit.optional(),
    childBenefitAmount: zRfpDependentBenefit.optional(),
    childBenefitMaximum: zRfpDependentBenefit.optional(),
    portability: zRfpInclusionStatusEnum.optional(),
    coverageEffectiveDate: zRfpWholeLifeCoverageEffectiveDateEnum.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional()
}));

export const zBenefitPlansRfpWholeLifeBenefitWithExtended = zRfpWholeLifeBenefit.and(z.object({
    extended: zBenefitPlansWholeLifeExtendedBenefit.optional()
}));

/**
 * Indicates if policy holder can continue policy after separation of employment and whether Evidence of Insurability would be required.
 */
export const zRfpPortabilityTypeEnum = z.enum([
    'included',
    'notIncluded',
    'includedWithEOI',
    'includedWithoutEOI'
]);

export const zBaseBasicLifeAdndBenefit = z.object({
    objectType: zRfpBasicLifeObjectTypeEnum,
    benefitAmount: z.object({
        type: zRfpBasicLifeBenefitAmountTypeEnum,
        dollarAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
        salaryMultiplier: z.number().gte(1).optional()
    }).optional(),
    benefitMaximum: z.object({
        type: zBenefitMaximumTypeEnum,
        dollarAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
        salaryMultiplier: z.number().gte(1).optional()
    }).optional(),
    guaranteeIssue: z.object({
        type: zRfpBasicLifeGuaranteeIssueTypeEnum,
        salaryMultiplier: z.number().gte(1).optional(),
        dollarAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional(),
        additionalAmount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    definitionOfEarnings: z.object({
        type: zDefinitionOfEarningsTypeEnum,
        earningsAverageMonths: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(36)).optional()
    }).optional(),
    portability: zRfpPortabilityTypeEnum.optional(),
    employerContribution: zEmployerContributionEnum.optional()
});

export const zRfpBasicLifeAdndBenefit = zBaseBasicLifeAdndBenefit.and(z.object({
    spouseBenefit: z.object({
        type: zRfpBasicLifeSpouseBenefitTypeEnum,
        amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    childBenefit: z.object({
        type: zRfpBasicLifeChildBenefitTypeEnum,
        amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    ageReductionSchedule: zRfpAgeReductionSchedule.optional(),
    conversion: zRfpInclusionStatusEnum.optional(),
    acceleratedDeathBenefit: zRfpInclusionStatusEnum.optional(),
    waiverOfPremium: zRfpInclusionStatusEnum.optional()
}));

export const zBenefitPlansRfpBasicLifeAdndBenefitWithExtended = zRfpBasicLifeAdndBenefit.and(z.object({
    extended: zBenefitPlansBasicLifeExtendedBenefit.optional()
}));

export const zRfpVoluntaryLifeAdndBenefit = z.object({
    objectType: z.enum(['voluntaryLifeAdnd']),
    employee: zRfpVoluntaryLifeEmployeeBenefit.optional(),
    spouse: zRfpVoluntaryLifeSpouseBenefit.optional(),
    child: zRfpVoluntaryLifeChildBenefit.optional(),
    definitionOfEarnings: zDefinitionOfEarnings.optional(),
    adndIncluded: zRfpInclusionStatusEnum.optional(),
    adndTiedToLife: zRfpVoluntaryLifeAdndTiedToLifeTypeEnum.optional(),
    ageReductionSchedule: zRfpVoluntaryLifeAgeReductionSchedule.optional(),
    conversion: zRfpInclusionStatusEnum.optional(),
    acceleratedDeathBenefit: zRfpInclusionStatusEnum.optional(),
    waiverOfPremium: zRfpInclusionStatusEnum.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional(),
    portability: zRfpPortabilityTypeEnum.optional()
});

export const zBenefitPlansRfpVoluntaryLifeAdndBenefitWithExtended = zRfpVoluntaryLifeAdndBenefit.and(z.object({
    extended: zBenefitPlansVoluntaryLifeAdndExtendedBenefit.optional()
}));

/**
 * Indicates the pre-existing condition type.
 */
export const zRfpPreExistingConditionTypeEnum = z.enum([
    'months',
    'waived',
    'none'
]);

/**
 * Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit.
 */
export const zRfpPreExistingCondition = z.object({
    type: zRfpPreExistingConditionTypeEnum,
    monthsDiagnosisFreeBeforeEffDate: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    monthsTreatmentFree: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    monthsDiagnosisFreeAfterEffDate: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

export const zRfpCancerBenefit = zBaseCancerBenefit.and(z.object({
    diagnosisBenefit: zRfpCancerAmountBenefit.optional(),
    radiationTherapyChemo: zRfpCancerAmountBenefit.optional(),
    bloodPlasmaPlatelets: zRfpCancerAmountBenefit.optional(),
    hospice: zRfpCancerHospiceBenefit.optional(),
    hospitalConfinementInitial: zRfpCancerAmountBenefit.optional(),
    icuConfinementInitial: zRfpCancerAmountBenefit.optional(),
    skinCancer: zRfpCancerScheduleBenefit.optional(),
    surgicalBenefit: zRfpCancerScheduleBenefit.optional(),
    preExistingCondition: zRfpPreExistingCondition.optional(),
    portability: zRfpInclusionStatusEnum.optional(),
    wellnessBenefit: zRfpCancerAmountBenefit.optional(),
    waiverOfPremium: zRfpInclusionStatusEnum.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional()
}));

export const zBenefitPlansRfpCancerBenefitWithExtended = zRfpCancerBenefit.and(z.object({
    extended: zBenefitPlansCancerExtendedBenefit.optional()
}));

export const zRfpCriticalIllnessBenefit = z.object({
    objectType: zCriticalIllnessObjectTypeEnum,
    employee: zRfpCriticalIllnessEmployeeBenefit.optional(),
    spouse: zRfpCriticalIllnessSpouseBenefit.optional(),
    child: zRfpCriticalIllnessChildBenefit.optional(),
    invasiveCancer: zRfpIllnessCoverage.optional(),
    nonInvasiveCancer: zRfpIllnessCoverage.optional(),
    category1HeartAttack: zRfpIllnessCoverage.optional(),
    category1Stroke: zRfpIllnessCoverage.optional(),
    kidneyFailure: zRfpIllnessCoverage.optional(),
    maximumPayout: zRfpMaximumPayout.optional(),
    occurrenceOfDifferentIllness: zRfpOccurrenceOfDifferentIllness.optional(),
    additionalOccurrenceOfSameIllness: zRfpAdditionalOccurrenceOfSameIllness.optional(),
    ageReductionSchedule: zRfpAgeReductionSchedule.optional(),
    preExistingCondition: zRfpPreExistingCondition.optional(),
    portability: zRfpInclusionStatusEnum.optional(),
    wellnessBenefit: zRfpWellnessBenefit.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional(),
    ageBasis: zRfpAgeBasisEnum.optional()
});

export const zBenefitPlansRfpCriticalIllnessBenefitWithExtended = zRfpCriticalIllnessBenefit.and(z.object({
    extended: zBenefitPlansCriticalIllnessExtendedBenefit.optional()
}));

export const zRfpHospitalIndemnityBenefit = z.object({
    objectType: z.enum(['hospitalIndemnity']),
    hospitalAdmission: zRfpBenefitAmountDetails.optional(),
    icuAdmission: zRfpBenefitAmountDetails.optional(),
    hospitalConfinement: zRfpBenefitAmountDetails.optional(),
    icuConfinement: zRfpBenefitAmountDetails.optional(),
    preExistingCondition: zRfpPreExistingCondition.optional(),
    portability: zRfpInclusionStatusEnum.optional(),
    wellness: zRfpBenefitAmountDetails.optional(),
    annualOpenEnrollment: zRfpAnnualOpenEnrollmentEnum.optional()
});

export const zBenefitPlansRfpHospitalIndemnityBenefitWithExtended = zRfpHospitalIndemnityBenefit.and(z.object({
    extended: zBenefitPlansHospitalIndemnityExtendedBenefit.optional()
}));

export const zRfpIndividualDisabilityBenefit = zBaseIndividualDisabilityBenefit.and(z.object({
    preExistingCondition: zRfpPreExistingCondition.optional(),
    ltdPlanDesign: z.object({
        type: zRfpLtdPlanDesignTypeEnum,
        percent: z.number().gte(0).optional(),
        dollarAmount: z.number().gte(0).optional()
    }).optional(),
    idiPlanDesign: z.object({
        type: zRfpIdiPlanDesignTypeEnum,
        percent: z.number().gte(0).optional(),
        dollarAmount: z.number().gte(0).optional()
    }).optional(),
    gsiBenefitMaximum: z.number().gte(0).optional(),
    ownOccupationPeriod: z.object({
        type: zRfpIndividualDisabilityOwnOccupationPeriodTypeEnum,
        amount: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    eliminationPeriodDays: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    mentalIllnessBenefit: z.object({
        type: zRfpIndividualDisabilityMentalIllnessBenefitTypeEnum,
        timeframe: z.number().gte(0).optional()
    }).optional(),
    recoveryBenefit: z.object({
        type: zRfpRecoveryBenefitEnum,
        amount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    catastrophicBenefit: z.object({
        type: zRfpCatastrophicBenefitEnum,
        amount: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
    }).optional(),
    portability: zRfpIndividualDisabilityPortabilityEnum.optional()
}));

export const zRfpLtdBenefit = zBaseLtdBenefit.and(z.object({
    guaranteedIssue: zRfpGuaranteedIssue.optional(),
    ownOccupationPeriod: zRfpOwnOccupationPeriod.optional(),
    gainfulEarningsTestOwnOccupation: zRfpGainfulEarningsTest.optional(),
    gainfulEarningsTestAnyOccupation: zRfpGainfulEarningsTest.optional(),
    eliminationPeriod: zRfpEliminationPeriod.optional(),
    benefitDuration: zBenefitDuration.optional(),
    otherLimitations: zRfpOtherLimitation.optional(),
    mentalIllness: zRfpLimitation.optional(),
    substanceAbuse: zRfpLimitation.optional(),
    preExistingCondition: zRfpPreExistingCondition.optional(),
    rehab: zRfpRehabTypeEnum.optional(),
    cola: zRfpInclusionStatusEnum.optional(),
    conversion: zRfpInclusionStatusEnum.optional(),
    waiverOfPremium: zRfpInclusionStatusEnum.optional()
}));

export const zBenefitPlansRfpLtdBenefitWithExtended = zRfpLtdBenefit.and(z.object({
    extended: zBenefitPlansLtdExtendedBenefit.optional()
}));

/**
 * Indicates the amount of months before effective date AND after effective date participant needs to be illness free to claim benefit.
 */
export const zRfpPreExistingConditionExtended = z.object({
    type: zRfpPreExistingConditionTypeEnum,
    monthsDiagnosisFreeBeforeEffDate: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    monthsTreatmentFree: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional(),
    monthsDiagnosisFreeAfterEffDate: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991)).optional()
});

export const zRfpStdBenefit = zBaseStdBenefit.and(z.object({
    eliminationPeriodAccident: zRfpEliminationPeriodType.optional(),
    eliminationPeriodIllness: zRfpEliminationPeriodType.optional(),
    benefitDuration: zRfpStdBenefitDuration.optional(),
    preExistingCondition: zRfpPreExistingConditionExtended.optional(),
    ficaMatch: zRfpFicaMatchEnum.optional(),
    billableType: zRfpBillableTypeEnum.optional()
}));

export const zBenefitPlansRfpStdBenefitWithExtended = zRfpStdBenefit.and(z.object({
    extended: zBenefitPlansStdExtendedBenefit.optional()
}));

/**
 * Coverage-specific benefit data (shape varies by coverage type).
 * Identical to the canonical RfpBenefitPlan `benefits` polymorphic
 * schema, except the dental, vision, hospital indemnity, basic life, STD,
 * LTD, critical illness, accident, cancer, whole life, and voluntary life
 * variants also carry `extended` (CD-1983, CD-1659/CD-1660, CD-2076,
 * CD-2070, CD-2068, CD-2067, CD-2074, CD-2073, CD-2075, CD-2072, CD-2071).
 *
 */
export const zBenefitPlansBenefitsWithExtended = z.union([
    z.object({
        objectType: z.literal('benefit-plans_RfpDentalBenefitWithExtended')
    }).and(zBenefitPlansRfpDentalBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpVisionBenefitWithExtended')
    }).and(zBenefitPlansRfpVisionBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpBasicLifeAdndBenefitWithExtended')
    }).and(zBenefitPlansRfpBasicLifeAdndBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpVoluntaryLifeAdndBenefitWithExtended')
    }).and(zBenefitPlansRfpVoluntaryLifeAdndBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpStdBenefitWithExtended')
    }).and(zBenefitPlansRfpStdBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpLtdBenefitWithExtended')
    }).and(zBenefitPlansRfpLtdBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpCriticalIllnessBenefitWithExtended')
    }).and(zBenefitPlansRfpCriticalIllnessBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpAccidentBenefitWithExtended')
    }).and(zBenefitPlansRfpAccidentBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpHospitalIndemnityBenefitWithExtended')
    }).and(zBenefitPlansRfpHospitalIndemnityBenefitWithExtended),
    z.object({
        objectType: z.literal('benefit-plans_RfpCancerBenefitWithExtended')
    }).and(zBenefitPlansRfpCancerBenefitWithExtended),
    z.object({
        objectType: z.literal('RfpFmlBenefit')
    }).and(zRfpFmlBenefit),
    z.object({
        objectType: z.literal('RfpEapBenefit')
    }).and(zRfpEapBenefit),
    z.object({
        objectType: z.literal('RfpIndividualDisabilityBenefit')
    }).and(zRfpIndividualDisabilityBenefit),
    z.object({
        objectType: z.literal('benefit-plans_RfpWholeLifeBenefitWithExtended')
    }).and(zBenefitPlansRfpWholeLifeBenefitWithExtended)
]);

/**
 * Partial update — only provided fields are changed
 */
export const zBenefitPlansUpdateBenefitPlanRequest = z.object({
    policyId: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    type: zBenefitPlanTypeEnum.optional(),
    policyPeriod: zPolicyPeriodEnum.optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().nullish(),
    optionName: zOptionNameEnum.optional(),
    currentCarrierName: z.string().nullish(),
    eligibilityClasses: z.array(zBenefitPlansEligibilityClass).nullish(),
    benefits: zBenefitPlansBenefitsWithExtended.optional(),
    clearBenefitFields: z.array(z.string()).optional()
});

export const zBenefitPlansBenefitPlanResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    identifier: z.string().optional(),
    policyId: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    type: zBenefitPlanTypeEnum.optional(),
    policyPeriod: zPolicyPeriodEnum.optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().nullish(),
    optionName: zOptionNameEnum.optional(),
    currentCarrierName: z.string().nullish(),
    isBenchmarkSeeded: z.boolean().optional().default(false),
    benefits: zBenefitPlansBenefitsWithExtended.optional(),
    eligibilityClasses: z.array(zBenefitPlansEligibilityClass).optional()
});

export const zBenefits = z.union([
    z.object({
        objectType: z.literal('RfpDentalBenefit')
    }).and(zRfpDentalBenefit),
    z.object({
        objectType: z.literal('RfpVisionBenefit')
    }).and(zRfpVisionBenefit),
    z.object({
        objectType: z.literal('RfpStdBenefit')
    }).and(zRfpStdBenefit),
    z.object({
        objectType: z.literal('RfpLtdBenefit')
    }).and(zRfpLtdBenefit),
    z.object({
        objectType: z.literal('RfpBasicLifeAdndBenefit')
    }).and(zRfpBasicLifeAdndBenefit),
    z.object({
        objectType: z.literal('RfpVoluntaryLifeAdndBenefit')
    }).and(zRfpVoluntaryLifeAdndBenefit),
    z.object({
        objectType: z.literal('RfpCriticalIllnessBenefit')
    }).and(zRfpCriticalIllnessBenefit),
    z.object({
        objectType: z.literal('RfpAccidentBenefit')
    }).and(zRfpAccidentBenefit),
    z.object({
        objectType: z.literal('RfpHospitalIndemnityBenefit')
    }).and(zRfpHospitalIndemnityBenefit),
    z.object({
        objectType: z.literal('RfpCancerBenefit')
    }).and(zRfpCancerBenefit),
    z.object({
        objectType: z.literal('RfpFmlBenefit')
    }).and(zRfpFmlBenefit),
    z.object({
        objectType: z.literal('RfpEapBenefit')
    }).and(zRfpEapBenefit),
    z.object({
        objectType: z.literal('RfpIndividualDisabilityBenefit')
    }).and(zRfpIndividualDisabilityBenefit),
    z.object({
        objectType: z.literal('RfpWholeLifeBenefit')
    }).and(zRfpWholeLifeBenefit)
]);

export const zProposalsUpdateProposalPlanBenefitsRequest = z.object({
    benefits: zBenefits
});

export const zProposalsCreateAnalystProposalRequest = z.object({
    carrierId: z.string(),
    carrierName: z.string().optional(),
    origin: z.enum(['analyst']),
    materialize: z.object({
        rfpBenefitPlanGroupId: z.string().uuid(),
        planPosition: z.number().int().gte(1),
        network: z.string().optional(),
        name: z.string().max(128).optional(),
        fundingType: zFundingTypeEnum.optional(),
        participationRequirements: z.string().optional(),
        rateGuarantee: zProposalsRateGuarantee.optional(),
        rateCap: z.string().optional(),
        benefits: zBenefits.optional(),
        commission: zProposalsUpdateProposalCommissionRequest.optional()
    })
});

/**
 * An individual quoted plan within a proposal
 */
export const zProposalsProposalPlanResponse = z.object({
    id: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    isPlaceholder: z.boolean().optional(),
    identifier: z.string().optional(),
    type: zBenefitPlanTypeEnum.optional(),
    optionName: zOptionNameEnum.optional(),
    name: z.string().nullish(),
    benefitClassAvailability: z.array(z.string()).optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().nullish(),
    rateGuarantee: zProposalsRateGuarantee.optional(),
    rateCap: z.string().nullish(),
    riderCharges: zProposalsRiderCharges.optional(),
    currentCarrierName: z.string().nullish(),
    rateSchedules: z.array(zProposalsProposalRateScheduleResponse).optional(),
    benefits: zBenefits.optional()
});

/**
 * A plan group within a proposal coverage
 */
export const zProposalsProposalPlanGroupResponse = z.object({
    id: z.string().optional(),
    carrierQuoteVersion: z.number().int().nullish(),
    enrollmentGroupFlagged: z.boolean().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    productType: zBenefitPlanTypeEnum.optional(),
    position: z.number().int().optional(),
    nickname: z.string().nullish(),
    footnote: z.string().nullish(),
    size: z.number().int().optional(),
    planRole: z.string().optional(),
    rfpBenefitPlanGroupId: z.string().nullish(),
    isCurrent: z.boolean().optional(),
    sequencePosition: z.number().int().optional(),
    networkMode: z.string().optional(),
    isPlaceholder: z.boolean().optional(),
    groupRole: z.enum(['primary', 'alternate']).optional(),
    plans: z.array(zProposalsProposalPlanResponse).optional(),
    isActiveVersion: z.boolean().nullish(),
    requoteReviewState: z.enum(['pending', 'actioned']).optional(),
    deletedAt: z.string().datetime().nullish()
});

export const zRfpsBenefitPlanResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    identifier: z.string().optional(),
    policyId: z.coerce.bigint().min(BigInt('-9223372036854775808'), { message: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { message: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    type: zBenefitPlanTypeEnum.optional(),
    policyPeriod: zPolicyPeriodEnum.optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().nullish(),
    optionName: zOptionNameEnum.optional(),
    currentCarrierName: z.string().nullish(),
    isBenchmarkSeeded: z.boolean().optional().default(false),
    benefits: zBenefits.optional(),
    eligibilityClasses: z.array(zRfpsEligibilityClass).optional()
});

/**
 * Types of coverage, aka line of coverage (LoC). We don't see standalone AD&D often. However, it is still a valid coverage type that is usually part of life plans.
 */
export const zCoverageTypeEnum = z.enum([
    'dental',
    'vision',
    'std',
    'ltd',
    'basicLifeAdnd',
    'voluntaryLifeAdnd',
    'accident',
    'criticalIllness',
    'hospitalIndemnity',
    'cancer',
    'fmla',
    'eap',
    'individualDisabilityInsurance',
    'wholeLife'
]);

export const zBenefitPlansCoverageType = zCoverageTypeEnum;

/**
 * Create a new group from scratch with empty plan shells.
 */
export const zBenefitPlansCreateBenefitPlanGroupFromScratch = z.object({
    rfpId: z.string(),
    coverageType: zCoverageTypeEnum,
    benefitPlanGroup: zBenefitPlansBenefitPlanGroupInput
});

/**
 * The mode is determined by which fields are present:
 * - `rfpId` + `coverageType` → create from scratch
 * - `referenceGroupId` → clone from existing
 *
 */
export const zBenefitPlansCreateBenefitPlanGroupRequest = z.union([
    zBenefitPlansCreateBenefitPlanGroupFromScratch,
    zBenefitPlansCreateBenefitPlanGroupFromExisting
]);

/**
 * Matched to an existing plan by the composite key
 * (`coverageType` + `type` + `policyPeriod` + `optionName`).
 * If found, the plan is updated. If not, a new plan is created.
 *
 */
export const zBenefitPlansUpsertBenefitPlanItem = z.object({
    coverageType: zCoverageTypeEnum,
    type: zBenefitPlanTypeEnum,
    policyPeriod: zPolicyPeriodEnum,
    optionName: zOptionNameEnum,
    fundingType: zFundingTypeEnum.optional(),
    currentCarrierName: z.string().nullish(),
    participationRequirements: z.string().nullish(),
    eligibilityClasses: z.array(zBenefitPlansEligibilityClass).nullish(),
    benefits: zBenefitPlansBenefitsWithExtended.optional()
});

/**
 * Wrapper object that leaves room for future top-level metadata
 * (e.g., `dryRun`, `source`). The plan data is nested under `plan`.
 *
 */
export const zBenefitPlansUpsertBenefitPlanRequest = z.object({
    plan: zBenefitPlansUpsertBenefitPlanItem,
    skipClaimExisting: z.boolean().optional().default(false)
});

export const zBenefitPlansCoverageResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    rfpId: z.string().optional(),
    type: zCoverageTypeEnum.optional(),
    benefitPlans: z.array(zBenefitPlansBenefitPlanResponse).optional(),
    benefitClasses: z.array(zBenefitPlansEligibilityClass).optional()
});

export const zBenefitPlansBenefitPlanGroupResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    coverage: zBenefitPlansCoverageResponse.optional(),
    productType: zBenefitPlanTypeEnum.optional(),
    policyPeriod: zPolicyPeriodEnum.optional(),
    position: z.number().int().optional(),
    nickname: z.string().nullish(),
    footnoteHeaderLabel: z.string().nullish(),
    illustratedFrom: z.string().nullish(),
    size: z.number().int().optional(),
    benefitPlans: z.array(zBenefitPlansBenefitPlanResponse).optional()
});

export const zProposalsCoverageType = zCoverageTypeEnum;

/**
 * A coverage within a proposal
 */
export const zProposalsProposalCoverageResponse = z.object({
    id: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    type: zCoverageTypeEnum.optional(),
    rfpCoverageId: z.string().nullish(),
    status: z.string().optional(),
    statusReason: z.string().nullish(),
    requestedProductPlanTypes: z.array(zBenefitPlanTypeEnum).nullish(),
    planGroups: z.array(zProposalsProposalPlanGroupResponse).optional()
});

/**
 * Full proposal with nested entity tree
 */
export const zProposalsProposalDetailResponse = z.object({
    id: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    rfpId: z.string().optional(),
    carrierId: z.string().optional(),
    carrierName: z.string().optional(),
    status: z.string().optional(),
    rfpVersion: z.number().int().min(-2147483648, { message: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { message: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    isActiveVersion: z.boolean().optional(),
    requoteReviewState: z.enum(['pending', 'actioned']).optional(),
    receivedAt: z.string().datetime().nullish(),
    origin: z.enum([
        'carrier',
        'analyst',
        'document'
    ]).optional(),
    documentId: z.string().nullish(),
    documentName: z.string().nullish(),
    coverages: z.array(zProposalsProposalCoverageResponse).optional()
});

export const zRfpsCoverageType = zCoverageTypeEnum;

export const zRfpsCommissionResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    benefitPlanId: z.string().uuid().optional(),
    coverageType: zCoverageTypeEnum.optional(),
    currentType: z.string().optional(),
    currentAmount: z.number().nullish(),
    currentHeapedAmount: z.array(z.number()).nullish(),
    requestedType: z.string().optional(),
    requestedAmount: z.number().nullish(),
    requestedHeapedAmount: z.array(z.number()).nullish()
});

export const zRfpsBrokerResponse = z.object({
    commissions: z.array(zRfpsCommissionResponse).optional()
});

export const zRfpsCoverageResponse = z.object({
    id: z.string().uuid().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    rfpId: z.string().optional(),
    type: zCoverageTypeEnum.optional(),
    benefitPlans: z.array(zRfpsBenefitPlanResponse).optional(),
    benefitClasses: z.array(zRfpsEligibilityClass).optional()
});

export const zRfpsRfpResponse = z.object({
    id: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
    identifier: z.string().optional(),
    broker: zRfpsBrokerResponse.optional(),
    coverages: z.array(zRfpsCoverageResponse).optional(),
    note: z.string().nullish()
});

/**
 * Benefit plan group ID
 */
export const zBenefitPlansGroupId = z.string().uuid();

/**
 * Override the RFP specification version for this request.
 * Declares the version of the payload being sent and the
 * version expected in the response. When omitted, the default
 * version `5.0.6` is used.
 *
 */
export const zBenefitPlansRfpSpecVersion = z.string();

/**
 * Override the RFP specification version for this request.
 * Declares the version of the payload expected in the response.
 * When omitted, the default version `5.0.6` is used.
 *
 */
export const zProposalsRfpSpecVersion = z.string();

/**
 * Override the RFP specification version for this request.
 * Declares the version of the payload expected in the response.
 * When omitted, the default version `5.0.6` is used.
 *
 */
export const zRfpsRfpSpecVersion = z.string();

export const zBenefitPlansListBenefitPlanGroupsHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zBenefitPlansListBenefitPlanGroupsQuery = z.object({
    rfpId: z.string(),
    coverageType: zCoverageTypeEnum,
    productType: zBenefitPlanTypeEnum.optional()
});

/**
 * List of groups
 */
export const zBenefitPlansListBenefitPlanGroupsResponse = z.object({
    benefitPlanGroups: z.array(zBenefitPlansBenefitPlanGroupResponse).optional()
});

export const zBenefitPlansCreateBenefitPlanGroupBody = zBenefitPlansCreateBenefitPlanGroupRequest;

export const zBenefitPlansCreateBenefitPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

/**
 * Group created
 */
export const zBenefitPlansCreateBenefitPlanGroupResponse = zBenefitPlansBenefitPlanGroupResponse;

export const zBenefitPlansDeleteBenefitPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * Group deleted
 */
export const zBenefitPlansDeleteBenefitPlanGroupResponse = z.void();

export const zBenefitPlansGetBenefitPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zBenefitPlansGetBenefitPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * Group found
 */
export const zBenefitPlansGetBenefitPlanGroupResponse = zBenefitPlansBenefitPlanGroupResponse;

export const zBenefitPlansUpdateBenefitPlanGroupBody = zBenefitPlansUpdateBenefitPlanGroupRequest;

export const zBenefitPlansUpdateBenefitPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zBenefitPlansUpdateBenefitPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * Group updated
 */
export const zBenefitPlansUpdateBenefitPlanGroupResponse = zBenefitPlansBenefitPlanGroupResponse;

export const zBenefitPlansGetBenefitPlanGroupPremiumsPath = z.object({
    id: z.string().uuid()
});

/**
 * Group premiums
 */
export const zBenefitPlansGetBenefitPlanGroupPremiumsResponse = zBenefitPlansBenefitPlanGroupPremiumsResponse;

export const zBenefitPlansReorderBenefitPlanGroupsBody = zBenefitPlansReorderRequest;

export const zBenefitPlansReorderBenefitPlanGroupsQuery = z.object({
    rfpId: z.string(),
    coverageType: zCoverageTypeEnum,
    productType: zBenefitPlanTypeEnum
});

/**
 * Groups reordered
 */
export const zBenefitPlansReorderBenefitPlanGroupsResponse = z.array(zBenefitPlansBenefitPlanGroupResponse);

export const zBenefitPlansUpsertBenefitPlanBody = zBenefitPlansUpsertBenefitPlanRequest;

export const zBenefitPlansUpsertBenefitPlanPath = z.object({
    rfpId: z.string()
});

/**
 * Plan upserted — returns the full plan record
 */
export const zBenefitPlansUpsertBenefitPlanResponse = zBenefitPlansBenefitPlanResponse;

export const zBenefitPlansUpdateBenefitPlanBody = zBenefitPlansUpdateBenefitPlanRequest;

export const zBenefitPlansUpdateBenefitPlanHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zBenefitPlansUpdateBenefitPlanPath = z.object({
    id: z.string()
});

/**
 * Plan updated
 */
export const zBenefitPlansUpdateBenefitPlanResponse = z.void();

export const zProposalsListProposalsForRfpHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsListProposalsForRfpPath = z.object({
    id: z.string()
});

export const zProposalsListProposalsForRfpQuery = z.object({
    include: z.enum(['coverages']).optional(),
    scope: z.enum(['board', 'all']).optional()
});

/**
 * List of proposals for the RFP. Returns `ProposalSummaryResponse[]`
 * by default; returns `ProposalDetailResponse[]` when
 * `include=coverages` is passed.
 *
 */
export const zProposalsListProposalsForRfpResponse = z.union([
    z.array(zProposalsProposalSummaryResponse),
    z.array(zProposalsProposalDetailResponse)
]);

export const zProposalsCreateProposalForRfpBody = zProposalsCreateAnalystProposalRequest;

export const zProposalsCreateProposalForRfpHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsCreateProposalForRfpPath = z.object({
    id: z.string()
});

/**
 * The created analyst proposal with its full nested tree.
 */
export const zProposalsCreateProposalForRfpResponse = zProposalsProposalDetailResponse;

export const zProposalsGetProposalHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsGetProposalPath = z.object({
    id: z.string()
});

/**
 * Full proposal with nested coverages, plan groups, and plans
 */
export const zProposalsGetProposalResponse = zProposalsProposalDetailResponse;

export const zProposalsUpdateProposalPlanBenefitsBody = zProposalsUpdateProposalPlanBenefitsRequest;

export const zProposalsUpdateProposalPlanBenefitsPath = z.object({
    id: z.string().uuid()
});

/**
 * Benefits updated successfully
 */
export const zProposalsUpdateProposalPlanBenefitsResponse = z.void();

export const zProposalsDeleteProposalPlanPath = z.object({
    id: z.string().uuid()
});

/**
 * Plan deleted successfully
 */
export const zProposalsDeleteProposalPlanResponse = z.void();

export const zProposalsUpdateProposalPlanFieldsBody = zProposalsUpdateProposalPlanFieldsRequest;

export const zProposalsUpdateProposalPlanFieldsPath = z.object({
    id: z.string().uuid()
});

/**
 * Plan fields updated successfully
 */
export const zProposalsUpdateProposalPlanFieldsResponse = z.void();

export const zProposalsRestoreProposalPlanPath = z.object({
    id: z.string().uuid()
});

/**
 * Plan restored successfully
 */
export const zProposalsRestoreProposalPlanResponse = z.void();

export const zProposalsDeleteProposalPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * Plan group deleted successfully
 */
export const zProposalsDeleteProposalPlanGroupResponse = z.void();

export const zProposalsUpdateProposalPlanGroupFieldsBody = zProposalsUpdateProposalPlanGroupFieldsRequest;

export const zProposalsUpdateProposalPlanGroupFieldsPath = z.object({
    id: z.string().uuid()
});

/**
 * Group fields updated successfully
 */
export const zProposalsUpdateProposalPlanGroupFieldsResponse = zProposalsProposalPlanGroupResponse;

export const zProposalsReplaceProposalPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsReplaceProposalPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * The promoted plan group.
 */
export const zProposalsReplaceProposalPlanGroupResponse = zProposalsProposalPlanGroupResponse;

export const zProposalsDisregardProposalPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsDisregardProposalPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * The disregarded plan group.
 */
export const zProposalsDisregardProposalPlanGroupResponse = zProposalsProposalPlanGroupResponse;

export const zProposalsPromoteProposalPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsPromoteProposalPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * The promoted plan group.
 */
export const zProposalsPromoteProposalPlanGroupResponse = zProposalsProposalPlanGroupResponse;

export const zProposalsRestoreProposalPlanGroupHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zProposalsRestoreProposalPlanGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * The restored plan group.
 */
export const zProposalsRestoreProposalPlanGroupResponse = zProposalsProposalPlanGroupResponse;

export const zProposalsAddProposalPlanToGroupBody = z.object({
    position: z.number().int().gte(1).lte(3),
    benefits: z.record(z.unknown()).optional(),
    type: zBenefitPlanTypeEnum.optional(),
    optionName: zOptionNameEnum.optional(),
    name: z.string().max(128).optional(),
    fundingType: zFundingTypeEnum.optional(),
    participationRequirements: z.string().optional(),
    rateGuarantee: zProposalsRateGuarantee.optional(),
    rateCap: z.string().optional()
});

export const zProposalsAddProposalPlanToGroupPath = z.object({
    id: z.string().uuid()
});

/**
 * Plan created
 */
export const zProposalsAddProposalPlanToGroupResponse = z.object({
    id: z.string()
});

export const zProposalsDeleteProposalCommissionPath = z.object({
    id: z.string().uuid(),
    proposalId: z.string().uuid(),
    proposalPlanId: z.string().uuid()
});

/**
 * Commission deleted successfully
 */
export const zProposalsDeleteProposalCommissionResponse = z.void();

export const zProposalsUpdateProposalCommissionBody = zProposalsUpdateProposalCommissionRequest;

export const zProposalsUpdateProposalCommissionPath = z.object({
    id: z.string().uuid(),
    proposalId: z.string().uuid(),
    proposalPlanId: z.string().uuid()
});

/**
 * Commission created or updated successfully
 */
export const zProposalsUpdateProposalCommissionResponse = z.void();

export const zRfpsGetRfpHeaders = z.object({
    'X-RFP-Spec-Version': z.string().optional()
});

export const zRfpsGetRfpPath = z.object({
    id: z.string()
});

/**
 * RFP with all nested coverages and plans
 */
export const zRfpsGetRfpResponse = zRfpsRfpResponse;

export const zRfpsExportRfpPayloadPath = z.object({
    id: z.string()
});

/**
 * The RFP's v5 payload and its spec version
 */
export const zRfpsExportRfpPayloadResponse = zRfpsRfpPayloadExportResponse;

export const zRfpsSetCoverageCompletionBody = zRfpsSetCoverageCompletionRequest;

export const zRfpsSetCoverageCompletionPath = z.object({
    id: z.string(),
    coverageType: zCoverageTypeEnum
});

export const zRfpsSetCoverageCompletionQuery = z.object({
    productType: zBenefitPlanTypeEnum.optional()
});

/**
 * Completion status updated successfully
 */
export const zRfpsSetCoverageCompletionResponse = z.void();

export const zRfpsListCarrierNoteExistencePath = z.object({
    id: z.string()
});

/**
 * List of carrier IDs with notes
 */
export const zRfpsListCarrierNoteExistenceResponse = zRfpsCarrierNoteExistenceResponse;

export const zRfpsUpsertFieldCommentsBody = zRfpsUpsertFieldCommentsRequest;

export const zRfpsUpsertFieldCommentsPath = z.object({
    id: z.string().uuid()
});

/**
 * The written comments, grouped by benefit plan in the order
 * the request listed them.
 *
 */
export const zRfpsUpsertFieldCommentsResponse2 = zRfpsUpsertFieldCommentsResponse;
